// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-figure {
  margin: 0 auto 1.5rem auto;
  text-align: left;
  max-width: 900px;
  width: 100%;
}

.overlay-video {
  max-width: 900px;
  margin: 0 auto 1.5rem auto;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

.overlay-video img,
.overlay-video iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  display: block;
}

.overlay-video-trigger {
  position: relative;
  padding: 0;
  cursor: pointer;
  border: 1px solid rgba(148, 163, 184, 0.35);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.overlay-video-trigger::after {
  content: '▶';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.45);
  color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.65rem;
  line-height: 1;
  opacity: 0;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);
  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  pointer-events: none;
}

.overlay-video-trigger:hover {
  border-color: rgba(148, 163, 184, 0.55);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
}

.overlay-video-trigger:hover::after,
.overlay-video-trigger:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

.App.dark .overlay-video-trigger,
.app-overlay-root.dark .overlay-video-trigger {
  border-color: rgba(75, 85, 99, 0.8);
}

.App.dark .overlay-video-trigger::after,
.app-overlay-root.dark .overlay-video-trigger::after {
  background: rgba(28, 38, 48, 0.92);
  border-color: rgba(75, 85, 99, 0.85);
  color: #f8fafc;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.App.dark .overlay-video-trigger:hover,
.app-overlay-root.dark .overlay-video-trigger:hover {
  border-color: rgba(107, 114, 128, 0.9);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.36);
}

.overlay-video-modal {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.6);
}

.overlay-video-modal-panel {
  width: min(960px, 100%);
  background: var(--surface-color);
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.32);
  overflow: hidden;
}

.overlay-video-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.3);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.overlay-video-modal-header.is-dragging { cursor: grabbing; }

.overlay-video-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  color: #111827;
}

.overlay-video-modal-close {
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  padding: 0;
  background: transparent;
  color: #9ca3af;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.15s;
}

.overlay-video-modal-close:hover {
  color: #111827;
}

.overlay-video-modal-close svg {
  width: 1.1rem;
  height: 1.1rem;
}

.overlay-video-modal-frame {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.overlay-video-modal-frame iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.App.dark .overlay-video-modal-panel,
.app-overlay-root.dark .overlay-video-modal-panel {
  background: #1c2630;
  border-color: #263447;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);
}

.App.dark .overlay-video-modal-header,
.app-overlay-root.dark .overlay-video-modal-header {
  border-bottom-color: rgba(75, 85, 99, 0.6);
}

.App.dark .overlay-video-modal-header h3,
.app-overlay-root.dark .overlay-video-modal-header h3 {
  color: #f9fafb;
}

.App.dark .overlay-video-modal-close,
.app-overlay-root.dark .overlay-video-modal-close {
  background: transparent;
  color: #6b7280;
}

.App.dark .overlay-video-modal-close:hover,
.app-overlay-root.dark .overlay-video-modal-close:hover {
  background: transparent;
  color: #e5e7eb;
}

.overlay-figure img {
  max-width: 900px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  display: block;
  margin: 0 auto;
}

.overlay-figure table {
  width: 100%;
  margin-top: 0;
}

.overlay-figure-caption,
.overlay-table-caption {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: rgba(71, 85, 105, 0.75);
  text-align: center;
  font-style: italic;
}

.App.dark .overlay-figure-caption,
.App.dark .overlay-table-caption,
.app-overlay-root.dark .overlay-figure-caption,
.app-overlay-root.dark .overlay-table-caption {
  color: rgba(226, 232, 240, 0.85);
}

.App.dark .overlay-figure img,
.app-overlay-root.dark .overlay-figure img {
  filter: grayscale(1) invert(1) brightness(1.1) contrast(0.95);
  mix-blend-mode: screen;
}

.overlay-figure--with-popout {
  position: relative;
}

.overlay-figure-popout-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
}

.overlay-article {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.7;
}

.overlay-article > * {
  margin-bottom: 1.5rem;
}

.overlay-article section {
  border-top: 1px solid rgba(148, 163, 184, 0.4);
  padding-top: 1.25rem;
  margin-top: 0.5rem;
}

.overlay-article section:first-of-type {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

.overlay-article .article-content > section:has(.account-access-card),
.overlay-article .article-content > section:has(.account-history-carousel),
.overlay-article .article-content > section:has(.account-history-nav-btn) {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

.overlay-article .article-content > section:has(.account-access-card) + section,
.overlay-article .article-content > section:has(.account-history-carousel) + section {
  margin-top: 1.1rem;
}

.overlay-article .article-intro {
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
  padding-bottom: 1rem;
  margin-bottom: 1.25rem;
}


.overlay-article .counsellors-intro-first {
  margin-bottom: 0.75rem;
}

.overlay-article h3 {
  margin: 0 0 0.75rem 0;
  font-size: 1.05rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lectures-overlay-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.lectures-overlay-card {
  min-width: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  outline: none;
  padding: 0;
  display: block;
  text-align: left;
  cursor: pointer;
  transition: transform 0.18s ease, opacity 0.18s ease;
}

.lectures-overlay-card:hover {
  transform: translateY(-1px);
  opacity: 0.94;
}

.lectures-overlay-card__thumb {
  position: relative;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  aspect-ratio: 16 / 9;
}

.lectures-overlay-card__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border: none;
  box-shadow: none;
}

.lectures-overlay-card__play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.lectures-overlay-card__play svg {
  width: 3.1rem;
  height: 3.1rem;
}

.sr-playground-card {
  margin-top: 1rem;
  background: var(--surface-panel-color);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.App.dark .sr-playground-card {
  background: #1c2630;
  border-color: #374151;
}

.sr-playground-divider {
  height: 1px;
  background: #e5e7eb;
}

.App.dark .sr-playground-divider {
  background: #374151;
}

.sr-playground-group-header {
  padding: 1.25rem 1.5rem 1rem;
}

.sr-playground-group-header h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
}

.sr-playground-group-header h4::after {
  content: '';
  display: block;
  width: 6rem;
  height: 2px;
  margin-top: 0.35rem;
  border-radius: 2px;
}

.sr-playground-group--metadata .sr-playground-group-header h4::after { background: #374151; }
.sr-playground-group--motivations .sr-playground-group-header h4::after { background: #16a34a; }
.sr-playground-group--barriers .sr-playground-group-header h4::after { background: #dc2626; }
.sr-playground-group--actions .sr-playground-group-header h4::after { background: #2563eb; }

.App.dark .sr-playground-group-header h4 {
  color: #f9fafb;
}

.App.dark .sr-playground-group--metadata .sr-playground-group-header h4::after { background: #6b7280; }
.App.dark .sr-playground-group--motivations .sr-playground-group-header h4::after { background: #22c55e; }
.App.dark .sr-playground-group--barriers .sr-playground-group-header h4::after { background: #ef4444; }
.App.dark .sr-playground-group--actions .sr-playground-group-header h4::after { background: #3b82f6; }

.sr-playground-group-desc,
.sr-playground-field-note,
.sr-playground-support-note,
.sr-playground-selection-status {
  margin: 0;
  font-size: 0.8rem;
  color: #6b7280;
  line-height: 1.4;
}

.App.dark .sr-playground-group-desc,
.App.dark .sr-playground-field-note,
.App.dark .sr-playground-support-note,
.App.dark .sr-playground-selection-status {
  color: #9ca3af;
}

.sr-playground-controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem 1.5rem;
  padding: 0 1.5rem 1.5rem;
}

.sr-playground-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.sr-playground-field label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
}

.App.dark .sr-playground-field label {
  color: #d1d5db;
}

.sr-playground-static-field {
  min-height: 38px;
  padding: 0.55rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  background: var(--surface-color);
  color: #111827;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.App.dark .sr-playground-static-field {
  background: #374151;
  border-color: #4b5563;
  color: #f9fafb;
}

.sr-playground-wheel-row {
  width: 390px;
  overscroll-behavior: contain;
}

.sr-playground-wheel-window {
  width: 390px;
  justify-content: flex-start;
  padding-left: 0.8rem;
  padding-right: 1.95rem;
  overscroll-behavior: contain;
}

.sr-playground-wheel-window .wheel-window-number {
  font-size: 0.88rem;
}

.cr-playground-controls {
  grid-template-columns: minmax(170px, 0.85fr) minmax(180px, 1fr) minmax(190px, 0.9fr);
  align-items: start;
}

.cr-playground-wheel-row,
.cr-playground-wheel-window {
  width: 100%;
  max-width: 220px;
}

.cr-playground-wheel-window .wheel-window-number {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sr-playground-turns {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.sr-playground-turn-btn {
  padding: 0.45rem 0.85rem;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  background: var(--surface-color);
  color: #374151;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.sr-playground-turn-btn:hover {
  border-color: #d1d5db;
}

.sr-playground-turn-btn.active {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

.App.dark .sr-playground-turn-btn {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.App.dark .sr-playground-turn-btn:hover {
  border-color: #6b7280;
}

.App.dark .sr-playground-turn-btn.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
}

.sr-playground-theme-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0 1.5rem 1.5rem;
}

.sr-playground-persona-list {
  margin: 0;
  padding: 0 2.7rem 1.5rem 2.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.sr-playground-persona-item {
  color: #111827;
  line-height: 1.5;
}

.sr-playground-theme-btn {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: var(--surface-color);
  color: #111827;
  text-align: left;
  padding: 0.75rem 0.85rem;
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, opacity 0.15s ease;
}

.sr-playground-theme-btn:hover:not(:disabled) {
  border-color: #d1d5db;
}

.sr-playground-theme-btn.selected.is-motivation {
  border-color: rgba(22, 163, 74, 0.5);
  background: rgba(240, 253, 244, 0.95);
}

.sr-playground-theme-btn.selected.is-barrier {
  border-color: rgba(220, 38, 38, 0.42);
  background: rgba(254, 242, 242, 0.95);
}

.sr-playground-theme-btn:disabled {
  opacity: 0.42;
  cursor: default;
}

.App.dark .sr-playground-theme-btn {
  background: #374151;
  border-color: #4b5563;
  color: #f9fafb;
}

.App.dark .sr-playground-persona-item {
  color: #f9fafb;
}

.App.dark .sr-playground-theme-btn:hover:not(:disabled) {
  border-color: #6b7280;
}

.App.dark .sr-playground-theme-btn.selected.is-motivation {
  border-color: rgba(34, 197, 94, 0.55);
  background: rgba(20, 83, 45, 0.42);
}

.App.dark .sr-playground-theme-btn.selected.is-barrier {
  border-color: rgba(239, 68, 68, 0.52);
  background: rgba(127, 29, 29, 0.38);
}

.sr-playground-actions {
  padding: 1rem 1.5rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
}

.sr-playground-generate-btn {
  min-width: 132px;
  height: 40px;
  padding: 0 1rem;
  border: 1px solid #1d4ed8;
  border-radius: 8px;
  background: #2563eb;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.sr-playground-generate-btn:hover:not(:disabled) {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.sr-playground-generate-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.App.dark .sr-playground-generate-btn {
  background: #3b82f6;
  border-color: #3b82f6;
}

.App.dark .sr-playground-generate-btn:hover:not(:disabled) {
  background: #2563eb;
  border-color: #2563eb;
}

.sr-playground-error {
  margin: 0;
  padding: 0 1.5rem 1.5rem;
  color: #b91c1c;
  font-size: 0.84rem;
}

.App.dark .sr-playground-error {
  color: #fca5a5;
}

.sr-playground-result {
  margin-top: 1rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.88);
  padding: 1.25rem 1.5rem;
}

.sr-playground-result h4 {
  margin: 0 0 0.75rem;
  font-size: 0.98rem;
  color: #111827;
}

.sr-playground-result-vignette {
  margin: 0;
  color: #334155;
}

.sr-playground-vignette-card {
  margin: 0 0 1rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.78);
}

.sr-playground-vignette-label {
  margin-bottom: 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.sr-playground-conversation {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.sr-playground-result-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.sr-playground-eye-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}

.sr-playground-eye-btn svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.light .sr-playground-eye-btn {
  color: #64748b;
}

.light .sr-playground-eye-btn:hover {
  background: rgba(100, 116, 139, 0.12);
  color: #475569;
}

.light .sr-playground-eye-btn.on {
  color: #2563eb;
}

.light .sr-playground-eye-btn.on:hover {
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
}

.App.dark .sr-playground-result {
  background: rgba(28, 38, 48, 0.96);
  border-color: rgba(71, 85, 105, 0.72);
}

.App.dark .sr-playground-result h4 {
  color: #f9fafb;
}

.App.dark .sr-playground-result-vignette {
  color: #cbd5e1;
}

.App.dark .sr-playground-vignette-card {
  background: rgba(15, 23, 42, 0.52);
  border-color: rgba(71, 85, 105, 0.7);
}

.App.dark .sr-playground-vignette-label {
  color: #94a3b8;
}

.sr-playground-target-hidden {
  color: #64748b;
  font-size: 0.88rem;
}

.App.dark .sr-playground-target-hidden {
  color: #94a3b8;
}

.dark .sr-playground-eye-btn {
  color: #9ca3af;
}

.dark .sr-playground-eye-btn:hover {
  background: rgba(156, 163, 175, 0.15);
  color: #d1d5db;
}

.dark .sr-playground-eye-btn.on {
  color: #60a5fa;
}

.dark .sr-playground-eye-btn.on:hover {
  background: rgba(96, 165, 250, 0.15);
  color: #93c5fd;
}

@media (max-width: 768px) {
  .sr-playground-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .sr-playground-generate-btn {
    width: 100%;
  }
}

.section-header-with-popout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.section-header-with-popout h4 {
  margin: 0;
}

.section-popout-btn {
  background: rgba(148, 163, 184, 0.15);
  border: none;
  border-radius: 4px;
  color: rgba(71, 85, 105, 0.7);
  cursor: pointer;
  font-size: 0.85rem;
  padding: 0.2rem 0.4rem;
  line-height: 1;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.section-popout-btn:hover {
  background: rgba(148, 163, 184, 0.3);
  color: rgba(71, 85, 105, 1);
}

.App.dark .section-popout-btn,
.app-overlay-root.dark .section-popout-btn {
  background: rgba(75, 85, 99, 0.4);
  color: rgba(226, 232, 240, 0.6);
}

.App.dark .section-popout-btn:hover,
.app-overlay-root.dark .section-popout-btn:hover {
  background: rgba(75, 85, 99, 0.6);
  color: rgba(226, 232, 240, 0.9);
}

.client-info-panel .client-overlay-content {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.client-info-panel h2,
.about-title,
.client-title,
.contact-title {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.client-info-panel h2 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.client-info-panel p {
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.client-info-panel p:last-child {
  margin-bottom: 0;
}

.landing-overlay-content,
.app-overlay-content {
  padding-top: 4.5rem;
}

.account-intro {
  max-width: 900px;
  margin: 0 auto 1.25rem;
  color: #475569;
  line-height: 1.6;
}

.App.dark .account-intro {
  color: rgba(226, 232, 240, 0.82);
}

.account-history-carousel {
  display: grid;
  gap: 1rem;
}

.account-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.account-section-head h3 {
  margin-bottom: 0;
}

.account-session-history {
  position: relative;
}

.account-session-history__head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-bottom: 0.9rem;
  padding-right: 11rem;
}

.account-session-history__selector {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.account-session-history__selector-label {
  color: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1.2;
  text-transform: uppercase;
  white-space: nowrap;
}

.account-session-history__label-mobile {
  display: none;
}

.account-session-history__selector-dropdown {
  display: inline-block;
}

.account-session-history__type-trigger {
  width: 8rem;
  min-width: 8rem;
  min-height: 2.05rem;
}

.account-session-history__type-menu {
  right: auto;
  left: 0;
  width: max-content;
  min-width: 100%;
  z-index: 20;
}

.App.dark .account-session-history__selector-label {
  color: #cbd5e1;
}

.account-session-history__toolbar {
  position: absolute;
  top: 0;
  right: 0;
  justify-content: flex-end;
  margin: 0;
}

.account-session-history__toolbar .account-filter-actions-row {
  margin-left: auto;
}

.account-session-history__toolbar:empty {
  display: none;
}

@media (max-width: 700px) {
  .account-session-history__head {
    align-items: center;
    padding-right: 5.2rem;
  }

  .account-session-history__selector {
    flex-direction: row;
    align-items: center;
    gap: 0.4rem;
  }

  .account-session-history__label-desktop {
    display: none;
  }

  .account-session-history__label-mobile {
    display: inline;
  }

  .account-session-history__toolbar {
    top: 0;
  }
}

.account-filter-wrap {
  position: relative;
  flex-shrink: 0;
}

.account-filter-actions-row {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.account-filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.34rem 0.62rem;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #334155;
  font-size: 0.77rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.account-filter-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.account-filter-btn:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.16);
}

.account-filter-btn svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
}

.account-filter-btn--clear {
  justify-content: center;
}

.account-filter-btn-clear-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.9rem;
  height: 0.9rem;
}

.account-filter-btn-clear-mark svg {
  width: 0.8rem;
  height: 0.8rem;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-filter-dropdown {
  position: absolute;
  top: calc(100% + 0.45rem);
  right: 0;
  z-index: 4;
  width: min(14.75rem, calc(100vw - 4rem));
  padding: 0.55rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06);
  display: grid;
  gap: 0.55rem;
}

.account-filter-field {
  display: grid;
  gap: 0.32rem;
}

.account-filter-field span {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.account-filter-choice {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.18rem 0.05rem;
  border: none;
  border-radius: 0;
  background: transparent;
  font-size: 0.8rem;
  color: #334155;
  cursor: pointer;
  transition: color 0.15s ease;
}

.account-filter-choice input {
  margin: 0;
  accent-color: #2563eb;
}

.account-filter-choice input:checked + .account-filter-choice-copy {
  color: #0f172a;
  font-weight: 600;
}

.account-filter-type-dropdown {
  position: relative;
}

.account-filter-type-trigger {
  width: 100%;
  min-height: 2.05rem;
  padding: 0.45rem 0.55rem;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #334155;
  font-size: 0.8rem;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.account-filter-type-trigger:hover {
  border-color: #d1d5db;
  background: #f8fafc;
}

.account-filter-type-trigger.open,
.account-filter-type-trigger:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.16);
}

.account-filter-type-trigger-copy {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-filter-type-trigger-arrow {
  flex-shrink: 0;
  color: #4b5563;
}

.account-filter-type-trigger-arrow svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-filter-type-menu {
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  width: 100%;
  max-height: 12rem;
  overflow-y: auto;
  background: var(--surface-color);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06);
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 1px;
  z-index: 5;
}

.account-filter-type-option {
  width: 100%;
  padding: 0.45rem 0.6rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #374151;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.account-filter-type-option:hover {
  background: #f3f4f6;
  color: #111827;
}

.account-filter-type-option.selected {
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  font-weight: 600;
}

.account-filter-actions {
  display: flex;
  justify-content: flex-end;
}

.account-filter-apply-btn {
  padding: 0.32rem 0.58rem;
  border: 1px solid rgba(59, 130, 246, 0.4);
  border-radius: 7px;
  background: rgba(219, 234, 254, 0.95);
  color: #1d4ed8;
  font-size: 0.76rem;
  font-weight: 600;
  cursor: pointer;
}

.account-history-carousel-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.account-history-carousel-controls--card {
  margin-top: 0.85rem;
}

.account-history-card-nav {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
  margin-top: 0.9rem;
}

.account-history-card-nav--inline {
  margin-top: 0;
  justify-self: end;
}

.account-history-card-nav-position {
  font-size: 0.85rem;
  opacity: 0.75;
}

.account-history-card-nav-position--center {
  justify-self: center;
}

.account-history-card-nav-buttons {
  display: flex;
  align-items: center;
  gap: 1.1rem;
}

.account-history-nav-btn {
  border: none;
  background: transparent;
  color: #475569;
  min-width: 0;
  padding: 0.1rem 0;
  font-size: 0.95rem;
  letter-spacing: 0.01em;
  line-height: 1;
  cursor: pointer;
  transition: color 0.18s ease, transform 0.18s ease, opacity 0.18s ease;
}

.account-history-nav-btn:hover:not(:disabled) {
  color: #0f172a;
  transform: translateY(-1px);
}

.account-history-nav-btn--action {
  font-size: 0.9rem;
  justify-self: start;
}

.account-history-nav-btn:disabled {
  opacity: 0.28;
  cursor: not-allowed;
}

.App.dark .account-history-nav-btn {
  background: transparent;
  color: rgba(226, 232, 240, 0.78);
}

.App.dark .account-history-nav-btn:hover:not(:disabled) {
  color: #f8fafc;
}

.App.dark .account-filter-btn {
  border-color: #374151;
  background: rgba(31, 41, 55, 0.96);
  color: rgba(241, 245, 249, 0.9);
}

.App.dark .account-filter-btn:hover {
  border-color: #4b5563;
  background: #273244;
}

.App.dark .account-filter-btn:focus-visible {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.22);
}

.App.dark .account-filter-dropdown {
  border-color: #374151;
  background: #1f2937;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35), 0 2px 6px rgba(0, 0, 0, 0.2);
}

.App.dark .account-filter-field span {
  color: rgba(226, 232, 240, 0.72);
}

.App.dark .account-filter-choice {
  color: rgba(241, 245, 249, 0.9);
}

.App.dark .account-filter-choice input:checked + .account-filter-choice-copy {
  color: #f8fafc;
}

.App.dark .account-filter-type-trigger {
  border-color: #374151;
  background: rgba(31, 41, 55, 0.96);
  color: #f8fafc;
}

.App.dark .account-filter-type-trigger:hover {
  border-color: #4b5563;
  background: #273244;
}

.App.dark .account-filter-type-trigger.open,
.App.dark .account-filter-type-trigger:focus-visible {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.22);
}

.App.dark .account-filter-type-trigger-arrow {
  color: #d1d5db;
}

.App.dark .account-filter-type-menu {
  background: #1f2937;
  border-color: #374151;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35), 0 2px 6px rgba(0, 0, 0, 0.2);
}

.App.dark .account-filter-type-option {
  color: #d1d5db;
}

.App.dark .account-filter-type-option:hover {
  background: #374151;
  color: #f9fafb;
}

.App.dark .account-filter-type-option.selected {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.App.dark .account-filter-apply-btn {
  border-color: rgba(96, 165, 250, 0.45);
  background: rgba(30, 64, 175, 0.34);
  color: #93c5fd;
}

.account-history-position {
  font-size: 0.9rem;
  opacity: 0.75;
}

.account-history-card {
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 12px;
  padding: 1rem 1.1rem;
  background: rgba(248, 250, 252, 0.7);
  min-width: 0;
}

.account-history-carousel {
  overflow: visible;
  perspective: 1000px;
}

.account-history-card--exit-next {
  transform-origin: 12% 88%;
  will-change: transform, opacity;
  animation: account-card-exit-next 140ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;
}

.account-history-card--enter-next {
  transform-origin: center top;
  will-change: transform, opacity;
  animation: account-card-enter-next 180ms cubic-bezier(0.22, 0.75, 0.25, 1) both;
}

.account-history-card--exit-previous {
  transform-origin: center top;
  will-change: transform, opacity;
  animation: account-card-exit-previous 140ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;
}

.account-history-card--enter-previous {
  transform-origin: 12% 88%;
  will-change: transform, opacity;
  animation: account-card-enter-previous 180ms cubic-bezier(0.2, 0.8, 0.25, 1) both;
}

@keyframes account-card-exit-next {
  35% {
    transform: translate(-4%, 5%) rotate(-2deg);
    box-shadow: 0 14px 24px rgba(15, 23, 42, 0.18);
  }

  45% {
    opacity: 1;
    transform: translate(-30%, 45%) rotate(-11deg);
    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.1);
  }

  95%,
  to {
    opacity: 0;
    transform: translate(-110%, 98%) rotate(-19deg);
    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.08);
  }
}

@keyframes account-card-enter-next {
  from {
    opacity: 0.72;
    transform: translateY(-0.65rem) scale(0.975);
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes account-card-exit-previous {
  to {
    opacity: 0.72;
    transform: translateY(-0.65rem) scale(0.975);
  }
}

@keyframes account-card-enter-previous {
  from {
    opacity: 0;
    transform: translate(-110%, 98%) rotate(-19deg);
    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.08);
  }

  55% {
    opacity: 1;
    transform: translate(-30%, 45%) rotate(-11deg);
  }

  70% {
    opacity: 1;
    transform: translate(-2%, 2%) rotate(-1deg);
    box-shadow: 0 14px 24px rgba(15, 23, 42, 0.18);
  }

  to {
    opacity: 1;
    transform: translate(0, 0) rotate(0);
  }
}

html[data-account-card-direction="next"]::view-transition-group(account-skills-card),
html[data-account-card-direction="next"]::view-transition-group(account-strategies-card),
html[data-account-card-direction="next"]::view-transition-group(account-session-card),
html[data-account-card-direction="previous"]::view-transition-group(account-skills-card),
html[data-account-card-direction="previous"]::view-transition-group(account-strategies-card),
html[data-account-card-direction="previous"]::view-transition-group(account-session-card) {
  animation-duration: 320ms;
}

html[data-account-card-direction="next"]::view-transition-new(account-skills-card),
html[data-account-card-direction="next"]::view-transition-new(account-strategies-card),
html[data-account-card-direction="next"]::view-transition-new(account-session-card) {
  z-index: 1;
  animation: account-card-underneath 320ms cubic-bezier(0.22, 0.75, 0.25, 1) both;
}

html[data-account-card-direction="next"]::view-transition-old(account-skills-card),
html[data-account-card-direction="next"]::view-transition-old(account-strategies-card),
html[data-account-card-direction="next"]::view-transition-old(account-session-card) {
  z-index: 2;
  transform-origin: 12% 88%;
  animation: account-card-exit-next 220ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;
}

html[data-account-card-direction="previous"]::view-transition-old(account-skills-card),
html[data-account-card-direction="previous"]::view-transition-old(account-strategies-card),
html[data-account-card-direction="previous"]::view-transition-old(account-session-card) {
  z-index: 1;
  animation: none;
}

html[data-account-card-direction="previous"]::view-transition-new(account-skills-card),
html[data-account-card-direction="previous"]::view-transition-new(account-strategies-card),
html[data-account-card-direction="previous"]::view-transition-new(account-session-card) {
  z-index: 2;
  transform-origin: 12% 88%;
  animation: account-card-enter-previous 220ms cubic-bezier(0.2, 0.8, 0.25, 1) both;
}

@keyframes account-card-underneath {
  from {
    opacity: 0.82;
    transform: translateY(-0.45rem) scale(0.985);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .account-history-card--exit-next,
  .account-history-card--enter-next,
  .account-history-card--exit-previous,
  .account-history-card--enter-previous {
    animation: none;
  }

  html[data-account-card-direction]::view-transition-old(account-skills-card),
  html[data-account-card-direction]::view-transition-new(account-skills-card),
  html[data-account-card-direction]::view-transition-old(account-strategies-card),
  html[data-account-card-direction]::view-transition-new(account-strategies-card),
  html[data-account-card-direction]::view-transition-old(account-session-card),
  html[data-account-card-direction]::view-transition-new(account-session-card) {
    animation: none;
  }
}

.account-access-card {
  display: grid;
  gap: 0.65rem;
  margin-top: 0.2rem;
}

.account-status-layout {
  display: grid;
  grid-template-columns: minmax(8.5rem, 0.3fr) minmax(0, 0.7fr);
  gap: 0.85rem;
  align-items: stretch;
  justify-content: end;
}

.account-status-card {
  display: grid;
  gap: 0.7rem;
  height: 14.5rem;
  align-self: stretch;
  overflow: hidden;
}

.account-status-card__body {
  min-height: 0;
  overflow-y: auto;
  display: grid;
  align-content: start;
  gap: 0.7rem;
  padding-right: 0.2rem;
}

.account-avatar-panel {
  display: grid;
  place-items: center;
  gap: 0.7rem;
  min-width: 0;
}

.account-avatar-panel__image-wrap {
  position: relative;
  width: clamp(8rem, 17vw, 10.5rem);
  aspect-ratio: 1;
}

.account-avatar-panel__image {
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  border-radius: 999px;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #ffffff;
}

.account-avatar-panel__change-btn {
  position: absolute;
  right: 0.1rem;
  bottom: 0.1rem;
  width: 2.35rem;
  height: 2.35rem;
  border: 1px solid rgba(37, 99, 235, 0.22);
  border-radius: 0.72rem;
  display: grid;
  place-items: center;
  padding: 0;
  background: rgba(239, 246, 255, 0.98);
  color: #1d4ed8;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.16);
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.account-avatar-panel__change-btn:hover {
  transform: translateY(-1px);
  background: rgba(219, 234, 254, 0.98);
  border-color: rgba(37, 99, 235, 0.36);
}

.account-avatar-panel__change-btn svg {
  width: 1.2rem;
  height: 1.2rem;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-avatar-panel__name {
  max-width: 100%;
  color: #1f2937;
  font-size: 1rem;
  line-height: 1.25;
  text-align: center;
  overflow-wrap: anywhere;
}

.account-avatar-editor {
  display: grid;
  grid-template-rows: auto auto auto;
  align-content: start;
  gap: 0.6rem;
}

.account-avatar-editor__section {
  min-width: 0;
  display: grid;
  align-items: center;
}

.account-avatar-editor__subtitle {
  margin: 0 0 0.35rem;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.account-avatar-editor__grid {
  display: grid;
  gap: 0.5rem;
}

.account-avatar-editor__grid--avatars {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.4rem;
}

.account-avatar-editor__avatar-option,
.account-avatar-editor__background-option {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.account-avatar-editor__avatar-option {
  display: grid;
  place-items: center;
}

.account-avatar-editor__avatar-option svg {
  width: 2.7rem;
  height: 2.7rem;
  display: block;
  border-radius: 50%;
  transition: box-shadow 0.18s ease, transform 0.18s ease;
}

.account-avatar-editor__avatar-option:hover svg {
  transform: translateY(-1px);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35);
}

.account-avatar-editor__avatar-option.is-selected svg {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.78);
}

.account-avatar-editor__error {
  color: #b91c1c;
  font-size: 0.9rem;
}

.account-avatar-editor__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.account-avatar-editor__slider {
  flex: 1 1 auto;
  min-width: 0;
}

.account-avatar-editor__slider input {
  appearance: none;
  width: 100%;
  margin: 0;
  accent-color: #2563eb;
  height: 0.7rem;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    hsl(0 88% 92%),
    hsl(60 88% 92%),
    hsl(120 88% 92%),
    hsl(180 88% 92%),
    hsl(240 88% 92%),
    hsl(300 88% 92%),
    hsl(360 88% 92%)
  );
  cursor: pointer;
}

.account-avatar-editor__slider input::-webkit-slider-thumb {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #2563eb;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.24);
}

.account-avatar-editor__slider input::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #2563eb;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.24);
}

.account-avatar-editor__slider input::-moz-range-track {
  height: 0.7rem;
  border: none;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    hsl(0 88% 92%),
    hsl(60 88% 92%),
    hsl(120 88% 92%),
    hsl(180 88% 92%),
    hsl(240 88% 92%),
    hsl(300 88% 92%),
    hsl(360 88% 92%)
  );
}

.account-avatar-editor__btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 0.45rem;
  flex: 0 0 auto;
}

.account-avatar-editor__btn {
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 0.7rem;
  padding: 0.42rem 0.82rem;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
}

.account-avatar-editor__btn:disabled {
  opacity: 0.62;
  cursor: not-allowed;
}

.account-avatar-editor__btn--ghost {
  background: rgba(255, 255, 255, 0.64);
  color: #475569;
}

.account-avatar-editor__btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}

.account-avatar-panel__image svg {
  width: 100%;
  height: 100%;
  display: block;
}

.account-access-card p {
  margin: 0;
}

.account-access-copy {
  display: grid;
  gap: 0.55rem;
  min-width: 0;
}

.account-access-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  position: relative;
}

.account-access-status-row p {
  min-width: 0;
}

.account-access-status-row--hoverable {
  cursor: default;
}

.account-access-hover-note {
  position: absolute;
  top: calc(100% + 0.45rem);
  left: 0;
  z-index: 2;
  width: min(28rem, calc(100vw - 6rem));
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  background: rgba(248, 250, 252, 0.96);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  color: #475569;
  font-size: 0.9rem;
  line-height: 1.5;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-0.2rem);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
}

.account-access-status-row--hoverable:hover .account-access-hover-note {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.App.dark .account-access-card {
  background: transparent;
  border-color: transparent;
}

.App.dark .account-avatar-panel__image {
  background: rgba(15, 23, 42, 0.86);
}

.App.dark .account-avatar-panel__change-btn {
  border-color: rgba(96, 165, 250, 0.26);
  background: rgba(15, 23, 42, 0.96);
  color: #bfdbfe;
  box-shadow: 0 10px 22px rgba(2, 6, 23, 0.36);
}

.App.dark .account-avatar-panel__change-btn:hover {
  background: rgba(30, 41, 59, 0.98);
  border-color: rgba(147, 197, 253, 0.42);
}

.App.dark .account-avatar-panel__name {
  color: #f9fafb;
}

.App.dark .account-avatar-editor__avatar-option {
  background: transparent;
}

.App.dark .account-avatar-editor__subtitle {
  color: rgba(203, 213, 225, 0.86);
}

.App.dark .account-avatar-editor__slider input {
  accent-color: #93c5fd;
}

.App.dark .account-avatar-editor__slider input::-webkit-slider-thumb {
  background: #93c5fd;
}

.App.dark .account-avatar-editor__slider input::-moz-range-thumb {
  background: #93c5fd;
}

.App.dark .account-avatar-editor__avatar-option:hover svg {
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.52);
}

.App.dark .account-avatar-editor__avatar-option.is-selected svg {
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.84);
}

.App.dark .account-avatar-editor__error {
  color: #fca5a5;
}

.App.dark .account-avatar-editor__btn--ghost {
  background: rgba(15, 23, 42, 0.6);
  color: rgba(226, 232, 240, 0.86);
}

.App.dark .account-avatar-editor__btn--primary {
  background: #1d4ed8;
  border-color: #3b82f6;
  color: #eff6ff;
}

.App.dark .account-access-hover-note {
  border-color: rgba(75, 85, 99, 0.8);
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.35);
  color: rgba(226, 232, 240, 0.86);
}

.App.dark .account-history-card {
  background: rgba(17, 24, 39, 0.45);
  border-color: rgba(75, 85, 99, 0.8);
}

.account-history-card-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: baseline;
  margin-bottom: 0.75rem;
}

.account-history-card-head-main {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
}

.account-history-card-head-main strong {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.account-attempt-retry-nav {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: #64748b;
  font-size: 0.8rem;
}

.account-attempt-retry-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  padding: 0 0.1rem;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 1.15rem;
  line-height: 1;
  transform: translateY(-0.1rem);
  cursor: pointer;
}

.account-attempt-retry-btn:hover:not(:disabled) {
  color: #2563eb;
}

.account-attempt-retry-btn:disabled {
  cursor: default;
  opacity: 0.3;
}

.App.dark .account-attempt-retry-nav,
.app-overlay-root.dark .account-attempt-retry-nav {
  color: #cbd5e1;
}

.account-history-card-position {
  font-size: 0.82rem;
  opacity: 0.72;
}

.account-history-card-head span {
  font-size: 0.85rem;
  opacity: 0.75;
}

.account-history-card-footer {
  flex: 0 0 auto;
  margin-top: 0.8rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.75rem;
}

.account-history-card-date {
  font-size: 0.85rem;
  opacity: 0.75;
}

.account-history-card-date__short,
.miti-chip__label-short {
  display: none;
}

.App.App--single-column .account-history-card-date__full,
.App.App--single-column .miti-chip--responsive-label .miti-chip__label-full {
  display: none;
}

.App.App--single-column .account-history-card-date__short,
.App.App--single-column .miti-chip--responsive-label .miti-chip__label-short {
  display: inline;
}

.App.App--single-column .account-full-session-title-activated {
  display: none;
}

.App.App--single-column .account-history-card--full-session .account-session-metrics {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.account-coding-chips {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  vertical-align: middle;
}

.account-coding-chips .miti-chip {
  font-weight: 600;
  letter-spacing: 0.03em;
  border-width: 1px;
}

.account-coding-chips .miti-chip--Q          { background: rgba(74,158,255,0.24);  border-color: rgba(74,158,255,0.48); }
.account-coding-chips .miti-chip--S          { background: rgba(240,168,78,0.24);  border-color: rgba(240,168,78,0.48); }
.account-coding-chips .miti-chip--AF         { background: rgba(76,175,136,0.24);  border-color: rgba(76,175,136,0.48); }
.account-coding-chips .miti-chip--SR         { background: rgba(47,158,158,0.24);  border-color: rgba(47,158,158,0.48); }
.account-coding-chips .miti-chip--CR         { background: rgba(201,126,240,0.24); border-color: rgba(201,126,240,0.48); }
.account-coding-chips .miti-chip--Seek       { background: rgba(240,168,78,0.24);  border-color: rgba(240,168,78,0.48); }
.account-coding-chips .miti-chip--GI         { background: rgba(56,189,248,0.24);  border-color: rgba(56,189,248,0.48); }
.account-coding-chips .miti-chip--Persuade   { background: rgba(251,113,133,0.24); border-color: rgba(251,113,133,0.48); }
.account-coding-chips .miti-chip--Persuade_with { background: rgba(251,146,60,0.24); border-color: rgba(251,146,60,0.48); }
.account-coding-chips .miti-chip--Emphasize  { background: rgba(52,211,153,0.24);  border-color: rgba(52,211,153,0.48); }
.account-coding-chips .miti-chip--Confront   { background: rgba(239,68,68,0.24);   border-color: rgba(239,68,68,0.48); }
.account-coding-chips .miti-chip--NC         { background: rgba(156,163,175,0.2);  border-color: rgba(156,163,175,0.42); }

.account-coding-chips--bubble {
  flex-shrink: 0;
  justify-content: flex-end;
}

.account-attempt-choice-pill {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 13.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
  padding: 0.14rem 0.42rem;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #e5e7eb;
  color: #475569;
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.03em;
}

.account-attempt-bubble {
  flex: 0 0 auto;
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
  margin: 0.95rem 0;
  padding: 0.95rem 1.1rem 1.05rem;
  border-radius: 18px;
  border: none;
}

.account-attempt-bubble--user {
  border-bottom-right-radius: 8px;
  background: #d7dce3;
}

.account-attempt-bubble--assistant {
  border-bottom-left-radius: 8px;
  background: #c3cad4;
}

.account-attempt-bubble__label {
  display: inline-block;
  margin-bottom: 0.45rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
}

.account-attempt-bubble__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
}

.account-attempt-bubble__head .account-attempt-bubble__label {
  margin-bottom: 0;
}

.account-attempt-bubble__text {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  color: #1f2937;
  line-height: 1.58;
  white-space: pre-wrap;
  word-break: break-word;
}

.account-attempt-bubble__text--input {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: normal;
}

.account-attempt-bubble__text--feedback {
  height: calc(1.58em * 4);
  overflow-y: auto;
}

.account-attempt-bubble__avatar {
  position: absolute;
  bottom: -0.55rem;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  background: #ffffff;
}

.account-attempt-bubble__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.account-attempt-bubble__avatar--user {
  right: 0.7rem;
}

.account-attempt-bubble__avatar--assistant {
  left: 0.7rem;
}

.account-session-end-reason {
  margin: 1rem 0 0.65rem;
  padding: 0.72rem 0.82rem;
  border: 1px solid #d1d5db;
  border-radius: 0.65rem;
  background: rgba(255, 255, 255, 0.42);
  text-align: left;
}

.account-session-end-reason__label {
  display: block;
  color: #6b7280;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
}

.account-session-end-reason__value {
  margin: 0.38rem 0 0;
  color: #1f2937;
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: left;
}

.account-session-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  margin: 0.75rem 0;
}

.account-session-metric {
  min-width: 0;
  display: grid;
  gap: 0.28rem;
}

.account-session-metric__label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.account-session-metric__value {
  font-size: 0.98rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.25;
}

.account-download-btn {
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  color: #0f172a;
  padding: 0.55rem 0.95rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.account-download-btn--icon {
  min-width: 2.4rem;
  padding: 0.5rem 0.7rem;
  font-size: 1.05rem;
  line-height: 1;
}

.account-download-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

.App.dark .account-download-btn {
  background: rgba(31, 41, 55, 0.85);
  color: #f8fafc;
  border-color: rgba(75, 85, 99, 0.9);
}

.App.dark .account-session-end-reason {
  background: rgba(15, 23, 42, 0.22);
  border-color: rgba(75, 85, 99, 0.75);
}

.App.dark .account-session-end-reason__label {
  color: #9ca3af;
}

.App.dark .account-session-end-reason__value {
  color: #e5e7eb;
}

.App.dark .account-session-metric__label {
  color: rgba(226, 232, 240, 0.68);
}

.App.dark .account-attempt-choice-pill {
  border-color: #4b5563;
  background: #374151;
  color: #cbd5e1;
}

.App.dark .account-session-metric__value {
  color: #f8fafc;
}

.App.dark .account-attempt-bubble {
  border: none;
}

.App.dark .account-attempt-bubble--user {
  background: #4b5563;
}

.App.dark .account-attempt-bubble--assistant {
  background: #303845;
}

.App.dark .account-attempt-bubble__label {
  color: #d1d5db;
}

.App.dark .account-attempt-bubble__text {
  color: #f9fafb;
}

.about-citation {
  font-size: 0.85rem;
  color: rgba(71, 85, 105, 0.9);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.about-citation a {
  color: #1d4ed8;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.about-citation a:hover {
  text-decoration: underline;
}

.App.dark .about-citation {
  color: rgba(226, 232, 240, 0.8);
}

.App.dark .about-citation a {
  color: #93c5fd;
}

.App.dark .lectures-overlay-card,
.app-overlay-root.dark .lectures-overlay-card {
  background: transparent;
}

.App.dark .lectures-overlay-card:hover,
.app-overlay-root.dark .lectures-overlay-card:hover {
  opacity: 0.94;
}

.App.dark .lectures-overlay-card__thumb,
.app-overlay-root.dark .lectures-overlay-card__thumb {
  border-color: rgba(75, 85, 99, 0.72);
}

.profile-table,
.io-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.92rem;
  column-span: all;
}

.profile-table th,
.profile-table td,
.io-table th,
.io-table td {
  border: 1px solid rgba(148, 163, 184, 0.5);
  padding: 0.75rem;
  vertical-align: top;
}

.profile-table th,
.io-table th {
  font-weight: 600;
  background: rgba(249, 250, 251, 0.8);
}

.App.dark .profile-table th,
.App.dark .io-table th {
  background: rgba(55, 65, 81, 0.8);
}

@media (max-width: 768px) {
  .section-popout-btn {
    padding: 0.3rem 0.5rem;
    font-size: 0.9rem;
  }

  .lectures-overlay-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .landing-overlay-content,
  .app-overlay-content {
    padding-top: 2.25rem;
  }

  .client-info-panel h2 {
    font-size: 1.25rem;
  }

  .client-info-panel p {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .account-status-layout {
    grid-template-columns: 1fr;
  }

  .account-status-card {
    height: 15.5rem;
  }

  .account-avatar-panel__image-wrap {
    width: clamp(6rem, 32vw, 8rem);
  }

  .account-avatar-editor__grid--avatars {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .account-avatar-editor__actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .account-avatar-editor__slider {
    flex-basis: 100%;
  }

  .account-session-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* --- Account token usage section --- */

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.overlay-article .article-content > section.account-usage-section {
  border-top: none;
  padding-top: 0;
}

.overlay-article .article-content > section.account-usage-section + section {
  margin-top: 1.1rem;
}

.account-usage-card {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  height: 19.2rem;
  overflow: hidden;
  transition: opacity 0.15s ease;
}

.account-usage-card.is-refetching {
  opacity: 0.55;
  pointer-events: none;
}

.account-usage-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.account-usage-summary {
  flex: 1 1 auto;
}

.account-usage-chip-group {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.3rem;
  margin-left: auto;
}

.account-usage-chip {
  padding: 0.3rem 0.6rem;
  border: 1px solid #d8dee8;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #334155;
  font-size: 0.74rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.account-usage-chip:hover {
  border-color: rgba(59, 130, 246, 0.55);
}

.account-usage-chip.is-active {
  border-color: rgba(59, 130, 246, 0.55);
  background: rgba(219, 234, 254, 0.95);
  color: #1d4ed8;
}

.account-usage-range-menu-wrap {
  display: none;
  position: relative;
  margin-left: auto;
}

.account-usage-range-trigger {
  min-width: 6.2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.35rem 0.55rem 0.35rem 0.65rem;
  border: 1px solid #d8dee8;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.96);
  color: #334155;
  font-family: inherit;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: none;
}

.account-usage-range-trigger svg {
  width: 0.8rem;
  height: 0.8rem;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-usage-range-trigger:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.36);
}

.account-usage-range-menu {
  position: absolute;
  top: calc(100% + 0.35rem);
  right: 0;
  width: 7.7rem;
  overflow: hidden;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: var(--surface-color);
  box-shadow: none;
  z-index: 20;
}

.account-usage-range-item {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  color: #374151;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  padding: 0.58rem 0.72rem;
  text-align: left;
}

.account-usage-range-item:hover,
.account-usage-range-item.is-active {
  background: #f3f4f6;
  color: #111827;
}

.account-usage-summary {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-width: 0;
}

.account-usage-summary__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.15;
  white-space: nowrap;
}

.account-usage-summary__unit {
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
}

.account-usage-summary__scope {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.account-usage-summary__delta {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
}

.App.App--single-column .account-usage-summary__delta {
  display: none;
}

.account-usage-summary__credits {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
}

.account-usage-summary__credits.is-exhausted {
  color: #b91c1c;
}

.App.dark .account-usage-summary__credits {
  color: rgba(226, 232, 240, 0.68);
}

.App.dark .account-usage-summary__credits.is-exhausted {
  color: #fca5a5;
}

.account-usage-chart {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
}

.account-usage-chart svg {
  display: block;
  outline: none;
}

.account-usage-chart svg:focus-visible {
  border-radius: 8px;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.45);
}

.account-usage-chart__gridline {
  stroke: rgba(148, 163, 184, 0.28);
  stroke-width: 1;
}

.account-usage-chart__baseline {
  stroke: rgba(100, 116, 139, 0.5);
  stroke-width: 1;
}

.account-usage-chart__tick {
  fill: #64748b;
  font-size: 0.66rem;
  font-variant-numeric: tabular-nums;
}

.account-usage-chart__line {
  fill: none;
  stroke: #3b82f6;
  stroke-width: 2;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.account-usage-chart__area {
  fill: rgba(59, 130, 246, 0.14);
  stroke: none;
}

.account-usage-chart__crosshair {
  stroke: rgba(100, 116, 139, 0.55);
  stroke-width: 1;
  stroke-dasharray: 3 3;
}

.account-usage-chart__marker {
  fill: #3b82f6;
  stroke: rgba(255, 255, 255, 0.95);
  stroke-width: 2;
}

.account-usage-tooltip {
  position: absolute;
  top: 4px;
  transform: translateX(-50%);
  display: grid;
  gap: 0.14rem;
  padding: 0.42rem 0.6rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
  pointer-events: none;
  z-index: 3;
  min-width: 7.5rem;
}

.account-usage-tooltip__value {
  font-size: 0.86rem;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
}

.account-usage-tooltip__label {
  font-size: 0.68rem;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

.account-usage-tooltip__breakdown {
  list-style: none;
  margin: 0.18rem 0 0;
  padding: 0.28rem 0 0;
  border-top: 1px solid rgba(148, 163, 184, 0.3);
  display: grid;
  gap: 0.12rem;
}

.account-usage-tooltip__breakdown li {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  white-space: nowrap;
}

.account-usage-tooltip__breakdown-value {
  font-size: 0.72rem;
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.account-usage-tooltip__breakdown-label {
  font-size: 0.68rem;
  color: #64748b;
}

.account-usage-empty-note {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
}

.App.dark .account-usage-chip {
  border-color: #374151;
  background: rgba(31, 41, 55, 0.85);
  color: #cbd5f5;
}

.App.dark .account-usage-chip:hover {
  border-color: rgba(96, 165, 250, 0.55);
}

.App.dark .account-usage-chip.is-active {
  border-color: rgba(96, 165, 250, 0.45);
  background: rgba(30, 64, 175, 0.34);
  color: #93c5fd;
}

.App.dark .account-usage-range-trigger {
  border-color: #374151;
  background: rgba(31, 41, 55, 0.85);
  color: #cbd5f5;
}

.App.dark .account-usage-range-menu {
  background: #1f2937;
  border-color: #4b5563;
}

.App.dark .account-usage-range-item {
  color: #d1d5db;
}

.App.dark .account-usage-range-item:hover,
.App.dark .account-usage-range-item.is-active {
  background: #374151;
  color: #f9fafb;
}

.App.dark .account-usage-summary__value {
  color: #f8fafc;
}

.App.dark .account-usage-summary__unit,
.App.dark .account-usage-summary__scope,
.App.dark .account-usage-summary__delta,
.App.dark .account-usage-empty-note {
  color: rgba(226, 232, 240, 0.68);
}

.App.dark .account-usage-chart__gridline {
  stroke: rgba(75, 85, 99, 0.45);
}

.App.dark .account-usage-chart__baseline {
  stroke: rgba(148, 163, 184, 0.45);
}

.App.dark .account-usage-chart__tick {
  fill: rgba(226, 232, 240, 0.6);
}

.App.dark .account-usage-chart__area {
  fill: rgba(59, 130, 246, 0.2);
}

.App.dark .account-usage-chart__marker {
  stroke: rgba(17, 24, 39, 0.95);
}

.App.dark .account-usage-tooltip {
  border-color: rgba(75, 85, 99, 0.8);
  background: rgba(17, 24, 39, 0.97);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.App.dark .account-usage-tooltip__value,
.App.dark .account-usage-tooltip__breakdown-value {
  color: #f8fafc;
}

.App.dark .account-usage-tooltip__label,
.App.dark .account-usage-tooltip__breakdown-label {
  color: rgba(226, 232, 240, 0.68);
}

.App.dark .account-usage-tooltip__breakdown {
  border-top-color: rgba(75, 85, 99, 0.7);
}

.App.App--single-column .account-usage-controls {
  justify-content: space-between;
}

.App.App--single-column .account-usage-chip-group {
  display: none;
}

.App.App--single-column .account-usage-range-menu-wrap {
  display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/overlays/OverlayContent.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,2CAA2C;EAC3C,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,6CAA6C;EAC7C,uHAAuH;EACvH,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0CAA0C,gBAAgB,EAAE;;AAE5D;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uEAAuE,mBAAmB,EAAE;AAC5F,0EAA0E,mBAAmB,EAAE;AAC/F,uEAAuE,mBAAmB,EAAE;AAC5F,sEAAsE,mBAAmB,EAAE;;AAE3F;EACE,cAAc;AAChB;;AAEA,iFAAiF,mBAAmB,EAAE;AACtG,oFAAoF,mBAAmB,EAAE;AACzG,iFAAiF,mBAAmB,EAAE;AACtG,gFAAgF,mBAAmB,EAAE;;AAErG;;;;EAIE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,MAAM;EACR;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,wEAAwE;EACxE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,wEAAwE;EACxE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wEAAwE;AAC1E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qFAAqF;AACvF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,+EAA+E;AACjF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,yFAAyF;AAC3F;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iFAAiF;AACnF;;AAEA;EACE;IACE,2CAA2C;IAC3C,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,8CAA8C;IAC9C,6CAA6C;EAC/C;;EAEA;;IAEE,UAAU;IACV,+CAA+C;IAC/C,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,aAAa;IACb,4CAA4C;IAC5C,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;IACb,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,UAAU;IACV,+CAA+C;IAC/C,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,2CAA2C;IAC3C,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,+EAA+E;AACjF;;AAEA;;;EAGE,UAAU;EACV,yBAAyB;EACzB,qFAAqF;AACvF;;AAEA;;;EAGE,UAAU;EACV,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,yBAAyB;EACzB,iFAAiF;AACnF;;AAEA;EACE;IACE,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,qCAAqC;EACrC,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,wGAAwG;AAC1G;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB;;;;;;;;;GASC;EACD,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB;;;;;;;;;GASC;AACH;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,UAAU;EACV,qCAAqC;EACrC,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,2EAA2E;AAC7E;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,kCAAkC,EAAE,oCAAoC,EAAE;AACzH,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,kCAAkC,EAAE,oCAAoC,EAAE;AACzH,kDAAkD,iCAAiC,EAAE,mCAAmC,EAAE;AAC1H,+CAA+C,iCAAiC,GAAG,mCAAmC,EAAE;AACxH,+CAA+C,gCAAgC,IAAI,kCAAkC,EAAE;AACvH,+CAA+C,iCAAiC,GAAG,oCAAoC,EAAE;;AAEzH;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAElB,gBAAgB;AAClB;;AAEA;;;;EAIE,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".overlay-figure {\n  margin: 0 auto 1.5rem auto;\n  text-align: left;\n  max-width: 900px;\n  width: 100%;\n}\n\n.overlay-video {\n  max-width: 900px;\n  margin: 0 auto 1.5rem auto;\n  aspect-ratio: 16 / 9;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n}\n\n.overlay-video img,\n.overlay-video iframe {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border: 0;\n  display: block;\n}\n\n.overlay-video-trigger {\n  position: relative;\n  padding: 0;\n  cursor: pointer;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.overlay-video-trigger::after {\n  content: '▶';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.9);\n  width: 64px;\n  height: 64px;\n  border-radius: 999px;\n  background: rgba(248, 250, 252, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.65rem;\n  line-height: 1;\n  opacity: 0;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  pointer-events: none;\n}\n\n.overlay-video-trigger:hover {\n  border-color: rgba(148, 163, 184, 0.55);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);\n}\n\n.overlay-video-trigger:hover::after,\n.overlay-video-trigger:focus-visible::after {\n  opacity: 1;\n  transform: translate(-50%, -50%) scale(1);\n}\n\n.App.dark .overlay-video-trigger,\n.app-overlay-root.dark .overlay-video-trigger {\n  border-color: rgba(75, 85, 99, 0.8);\n}\n\n.App.dark .overlay-video-trigger::after,\n.app-overlay-root.dark .overlay-video-trigger::after {\n  background: rgba(28, 38, 48, 0.92);\n  border-color: rgba(75, 85, 99, 0.85);\n  color: #f8fafc;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.App.dark .overlay-video-trigger:hover,\n.app-overlay-root.dark .overlay-video-trigger:hover {\n  border-color: rgba(107, 114, 128, 0.9);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.36);\n}\n\n.overlay-video-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(15, 23, 42, 0.6);\n}\n\n.overlay-video-modal-panel {\n  width: min(960px, 100%);\n  background: var(--surface-color);\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 12px;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.32);\n  overflow: hidden;\n}\n\n.overlay-video-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1.25rem;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.3);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.overlay-video-modal-header.is-dragging { cursor: grabbing; }\n\n.overlay-video-modal-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: #111827;\n}\n\n.overlay-video-modal-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  border: none;\n  padding: 0;\n  background: transparent;\n  color: #9ca3af;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.overlay-video-modal-close:hover {\n  color: #111827;\n}\n\n.overlay-video-modal-close svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.overlay-video-modal-frame {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #000;\n}\n\n.overlay-video-modal-frame iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n.App.dark .overlay-video-modal-panel,\n.app-overlay-root.dark .overlay-video-modal-panel {\n  background: #1c2630;\n  border-color: #263447;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);\n}\n\n.App.dark .overlay-video-modal-header,\n.app-overlay-root.dark .overlay-video-modal-header {\n  border-bottom-color: rgba(75, 85, 99, 0.6);\n}\n\n.App.dark .overlay-video-modal-header h3,\n.app-overlay-root.dark .overlay-video-modal-header h3 {\n  color: #f9fafb;\n}\n\n.App.dark .overlay-video-modal-close,\n.app-overlay-root.dark .overlay-video-modal-close {\n  background: transparent;\n  color: #6b7280;\n}\n\n.App.dark .overlay-video-modal-close:hover,\n.app-overlay-root.dark .overlay-video-modal-close:hover {\n  background: transparent;\n  color: #e5e7eb;\n}\n\n.overlay-figure img {\n  max-width: 900px;\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  display: block;\n  margin: 0 auto;\n}\n\n.overlay-figure table {\n  width: 100%;\n  margin-top: 0;\n}\n\n.overlay-figure-caption,\n.overlay-table-caption {\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: rgba(71, 85, 105, 0.75);\n  text-align: center;\n  font-style: italic;\n}\n\n.App.dark .overlay-figure-caption,\n.App.dark .overlay-table-caption,\n.app-overlay-root.dark .overlay-figure-caption,\n.app-overlay-root.dark .overlay-table-caption {\n  color: rgba(226, 232, 240, 0.85);\n}\n\n.App.dark .overlay-figure img,\n.app-overlay-root.dark .overlay-figure img {\n  filter: grayscale(1) invert(1) brightness(1.1) contrast(0.95);\n  mix-blend-mode: screen;\n}\n\n.overlay-figure--with-popout {\n  position: relative;\n}\n\n.overlay-figure-popout-btn {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  z-index: 1;\n}\n\n.overlay-article {\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.7;\n}\n\n.overlay-article > * {\n  margin-bottom: 1.5rem;\n}\n\n.overlay-article section {\n  border-top: 1px solid rgba(148, 163, 184, 0.4);\n  padding-top: 1.25rem;\n  margin-top: 0.5rem;\n}\n\n.overlay-article section:first-of-type {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n\n.overlay-article .article-content > section:has(.account-access-card),\n.overlay-article .article-content > section:has(.account-history-carousel),\n.overlay-article .article-content > section:has(.account-history-nav-btn) {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n\n.overlay-article .article-content > section:has(.account-access-card) + section,\n.overlay-article .article-content > section:has(.account-history-carousel) + section {\n  margin-top: 1.1rem;\n}\n\n.overlay-article .article-intro {\n  border-bottom: 1px solid rgba(148, 163, 184, 0.35);\n  padding-bottom: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n\n.overlay-article .counsellors-intro-first {\n  margin-bottom: 0.75rem;\n}\n\n.overlay-article h3 {\n  margin: 0 0 0.75rem 0;\n  font-size: 1.05rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.lectures-overlay-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.lectures-overlay-card {\n  min-width: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  outline: none;\n  padding: 0;\n  display: block;\n  text-align: left;\n  cursor: pointer;\n  transition: transform 0.18s ease, opacity 0.18s ease;\n}\n\n.lectures-overlay-card:hover {\n  transform: translateY(-1px);\n  opacity: 0.94;\n}\n\n.lectures-overlay-card__thumb {\n  position: relative;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 12px;\n  overflow: hidden;\n  background: transparent;\n  aspect-ratio: 16 / 9;\n}\n\n.lectures-overlay-card__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  border: none;\n  box-shadow: none;\n}\n\n.lectures-overlay-card__play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.lectures-overlay-card__play svg {\n  width: 3.1rem;\n  height: 3.1rem;\n}\n\n.sr-playground-card {\n  margin-top: 1rem;\n  background: var(--surface-panel-color);\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.App.dark .sr-playground-card {\n  background: #1c2630;\n  border-color: #374151;\n}\n\n.sr-playground-divider {\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.App.dark .sr-playground-divider {\n  background: #374151;\n}\n\n.sr-playground-group-header {\n  padding: 1.25rem 1.5rem 1rem;\n}\n\n.sr-playground-group-header h4 {\n  margin: 0 0 0.5rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.sr-playground-group-header h4::after {\n  content: '';\n  display: block;\n  width: 6rem;\n  height: 2px;\n  margin-top: 0.35rem;\n  border-radius: 2px;\n}\n\n.sr-playground-group--metadata .sr-playground-group-header h4::after { background: #374151; }\n.sr-playground-group--motivations .sr-playground-group-header h4::after { background: #16a34a; }\n.sr-playground-group--barriers .sr-playground-group-header h4::after { background: #dc2626; }\n.sr-playground-group--actions .sr-playground-group-header h4::after { background: #2563eb; }\n\n.App.dark .sr-playground-group-header h4 {\n  color: #f9fafb;\n}\n\n.App.dark .sr-playground-group--metadata .sr-playground-group-header h4::after { background: #6b7280; }\n.App.dark .sr-playground-group--motivations .sr-playground-group-header h4::after { background: #22c55e; }\n.App.dark .sr-playground-group--barriers .sr-playground-group-header h4::after { background: #ef4444; }\n.App.dark .sr-playground-group--actions .sr-playground-group-header h4::after { background: #3b82f6; }\n\n.sr-playground-group-desc,\n.sr-playground-field-note,\n.sr-playground-support-note,\n.sr-playground-selection-status {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.App.dark .sr-playground-group-desc,\n.App.dark .sr-playground-field-note,\n.App.dark .sr-playground-support-note,\n.App.dark .sr-playground-selection-status {\n  color: #9ca3af;\n}\n\n.sr-playground-controls {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem 1.5rem;\n  padding: 0 1.5rem 1.5rem;\n}\n\n.sr-playground-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.sr-playground-field label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.App.dark .sr-playground-field label {\n  color: #d1d5db;\n}\n\n.sr-playground-static-field {\n  min-height: 38px;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 7px;\n  background: var(--surface-color);\n  color: #111827;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n}\n\n.App.dark .sr-playground-static-field {\n  background: #374151;\n  border-color: #4b5563;\n  color: #f9fafb;\n}\n\n.sr-playground-wheel-row {\n  width: 390px;\n  overscroll-behavior: contain;\n}\n\n.sr-playground-wheel-window {\n  width: 390px;\n  justify-content: flex-start;\n  padding-left: 0.8rem;\n  padding-right: 1.95rem;\n  overscroll-behavior: contain;\n}\n\n.sr-playground-wheel-window .wheel-window-number {\n  font-size: 0.88rem;\n}\n\n.cr-playground-controls {\n  grid-template-columns: minmax(170px, 0.85fr) minmax(180px, 1fr) minmax(190px, 0.9fr);\n  align-items: start;\n}\n\n.cr-playground-wheel-row,\n.cr-playground-wheel-window {\n  width: 100%;\n  max-width: 220px;\n}\n\n.cr-playground-wheel-window .wheel-window-number {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sr-playground-turns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.sr-playground-turn-btn {\n  padding: 0.45rem 0.85rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 7px;\n  background: var(--surface-color);\n  color: #374151;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.sr-playground-turn-btn:hover {\n  border-color: #d1d5db;\n}\n\n.sr-playground-turn-btn.active {\n  background: #2563eb;\n  color: #ffffff;\n  border-color: #2563eb;\n}\n\n.App.dark .sr-playground-turn-btn {\n  background: #374151;\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.App.dark .sr-playground-turn-btn:hover {\n  border-color: #6b7280;\n}\n\n.App.dark .sr-playground-turn-btn.active {\n  background: #3b82f6;\n  border-color: #3b82f6;\n  color: #ffffff;\n}\n\n.sr-playground-theme-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0 1.5rem 1.5rem;\n}\n\n.sr-playground-persona-list {\n  margin: 0;\n  padding: 0 2.7rem 1.5rem 2.9rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.sr-playground-persona-item {\n  color: #111827;\n  line-height: 1.5;\n}\n\n.sr-playground-theme-btn {\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: var(--surface-color);\n  color: #111827;\n  text-align: left;\n  padding: 0.75rem 0.85rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, opacity 0.15s ease;\n}\n\n.sr-playground-theme-btn:hover:not(:disabled) {\n  border-color: #d1d5db;\n}\n\n.sr-playground-theme-btn.selected.is-motivation {\n  border-color: rgba(22, 163, 74, 0.5);\n  background: rgba(240, 253, 244, 0.95);\n}\n\n.sr-playground-theme-btn.selected.is-barrier {\n  border-color: rgba(220, 38, 38, 0.42);\n  background: rgba(254, 242, 242, 0.95);\n}\n\n.sr-playground-theme-btn:disabled {\n  opacity: 0.42;\n  cursor: default;\n}\n\n.App.dark .sr-playground-theme-btn {\n  background: #374151;\n  border-color: #4b5563;\n  color: #f9fafb;\n}\n\n.App.dark .sr-playground-persona-item {\n  color: #f9fafb;\n}\n\n.App.dark .sr-playground-theme-btn:hover:not(:disabled) {\n  border-color: #6b7280;\n}\n\n.App.dark .sr-playground-theme-btn.selected.is-motivation {\n  border-color: rgba(34, 197, 94, 0.55);\n  background: rgba(20, 83, 45, 0.42);\n}\n\n.App.dark .sr-playground-theme-btn.selected.is-barrier {\n  border-color: rgba(239, 68, 68, 0.52);\n  background: rgba(127, 29, 29, 0.38);\n}\n\n.sr-playground-actions {\n  padding: 1rem 1.5rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.sr-playground-generate-btn {\n  min-width: 132px;\n  height: 40px;\n  padding: 0 1rem;\n  border: 1px solid #1d4ed8;\n  border-radius: 8px;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.sr-playground-generate-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.sr-playground-generate-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.App.dark .sr-playground-generate-btn {\n  background: #3b82f6;\n  border-color: #3b82f6;\n}\n\n.App.dark .sr-playground-generate-btn:hover:not(:disabled) {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n.sr-playground-error {\n  margin: 0;\n  padding: 0 1.5rem 1.5rem;\n  color: #b91c1c;\n  font-size: 0.84rem;\n}\n\n.App.dark .sr-playground-error {\n  color: #fca5a5;\n}\n\n.sr-playground-result {\n  margin-top: 1rem;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.88);\n  padding: 1.25rem 1.5rem;\n}\n\n.sr-playground-result h4 {\n  margin: 0 0 0.75rem;\n  font-size: 0.98rem;\n  color: #111827;\n}\n\n.sr-playground-result-vignette {\n  margin: 0;\n  color: #334155;\n}\n\n.sr-playground-vignette-card {\n  margin: 0 0 1rem;\n  padding: 0.9rem 1rem;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.78);\n}\n\n.sr-playground-vignette-label {\n  margin-bottom: 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.sr-playground-conversation {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.sr-playground-result-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.sr-playground-eye-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.sr-playground-eye-btn svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.light .sr-playground-eye-btn {\n  color: #64748b;\n}\n\n.light .sr-playground-eye-btn:hover {\n  background: rgba(100, 116, 139, 0.12);\n  color: #475569;\n}\n\n.light .sr-playground-eye-btn.on {\n  color: #2563eb;\n}\n\n.light .sr-playground-eye-btn.on:hover {\n  background: rgba(37, 99, 235, 0.12);\n  color: #1d4ed8;\n}\n\n.App.dark .sr-playground-result {\n  background: rgba(28, 38, 48, 0.96);\n  border-color: rgba(71, 85, 105, 0.72);\n}\n\n.App.dark .sr-playground-result h4 {\n  color: #f9fafb;\n}\n\n.App.dark .sr-playground-result-vignette {\n  color: #cbd5e1;\n}\n\n.App.dark .sr-playground-vignette-card {\n  background: rgba(15, 23, 42, 0.52);\n  border-color: rgba(71, 85, 105, 0.7);\n}\n\n.App.dark .sr-playground-vignette-label {\n  color: #94a3b8;\n}\n\n.sr-playground-target-hidden {\n  color: #64748b;\n  font-size: 0.88rem;\n}\n\n.App.dark .sr-playground-target-hidden {\n  color: #94a3b8;\n}\n\n.dark .sr-playground-eye-btn {\n  color: #9ca3af;\n}\n\n.dark .sr-playground-eye-btn:hover {\n  background: rgba(156, 163, 175, 0.15);\n  color: #d1d5db;\n}\n\n.dark .sr-playground-eye-btn.on {\n  color: #60a5fa;\n}\n\n.dark .sr-playground-eye-btn.on:hover {\n  background: rgba(96, 165, 250, 0.15);\n  color: #93c5fd;\n}\n\n@media (max-width: 768px) {\n  .sr-playground-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .sr-playground-generate-btn {\n    width: 100%;\n  }\n}\n\n.section-header-with-popout {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.section-header-with-popout h4 {\n  margin: 0;\n}\n\n.section-popout-btn {\n  background: rgba(148, 163, 184, 0.15);\n  border: none;\n  border-radius: 4px;\n  color: rgba(71, 85, 105, 0.7);\n  cursor: pointer;\n  font-size: 0.85rem;\n  padding: 0.2rem 0.4rem;\n  line-height: 1;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.section-popout-btn:hover {\n  background: rgba(148, 163, 184, 0.3);\n  color: rgba(71, 85, 105, 1);\n}\n\n.App.dark .section-popout-btn,\n.app-overlay-root.dark .section-popout-btn {\n  background: rgba(75, 85, 99, 0.4);\n  color: rgba(226, 232, 240, 0.6);\n}\n\n.App.dark .section-popout-btn:hover,\n.app-overlay-root.dark .section-popout-btn:hover {\n  background: rgba(75, 85, 99, 0.6);\n  color: rgba(226, 232, 240, 0.9);\n}\n\n.client-info-panel .client-overlay-content {\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n}\n\n.client-info-panel h2,\n.about-title,\n.client-title,\n.contact-title {\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: left;\n}\n\n.client-info-panel h2 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.client-info-panel p {\n  margin-bottom: 1rem;\n  font-size: 0.95rem;\n}\n\n.client-info-panel p:last-child {\n  margin-bottom: 0;\n}\n\n.landing-overlay-content,\n.app-overlay-content {\n  padding-top: 4.5rem;\n}\n\n.account-intro {\n  max-width: 900px;\n  margin: 0 auto 1.25rem;\n  color: #475569;\n  line-height: 1.6;\n}\n\n.App.dark .account-intro {\n  color: rgba(226, 232, 240, 0.82);\n}\n\n.account-history-carousel {\n  display: grid;\n  gap: 1rem;\n}\n\n.account-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.account-section-head h3 {\n  margin-bottom: 0;\n}\n\n.account-session-history {\n  position: relative;\n}\n\n.account-session-history__head {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.9rem;\n  padding-right: 11rem;\n}\n\n.account-session-history__selector {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.account-session-history__selector-label {\n  color: inherit;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  line-height: 1.2;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.account-session-history__label-mobile {\n  display: none;\n}\n\n.account-session-history__selector-dropdown {\n  display: inline-block;\n}\n\n.account-session-history__type-trigger {\n  width: 8rem;\n  min-width: 8rem;\n  min-height: 2.05rem;\n}\n\n.account-session-history__type-menu {\n  right: auto;\n  left: 0;\n  width: max-content;\n  min-width: 100%;\n  z-index: 20;\n}\n\n.App.dark .account-session-history__selector-label {\n  color: #cbd5e1;\n}\n\n.account-session-history__toolbar {\n  position: absolute;\n  top: 0;\n  right: 0;\n  justify-content: flex-end;\n  margin: 0;\n}\n\n.account-session-history__toolbar .account-filter-actions-row {\n  margin-left: auto;\n}\n\n.account-session-history__toolbar:empty {\n  display: none;\n}\n\n@media (max-width: 700px) {\n  .account-session-history__head {\n    align-items: center;\n    padding-right: 5.2rem;\n  }\n\n  .account-session-history__selector {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.4rem;\n  }\n\n  .account-session-history__label-desktop {\n    display: none;\n  }\n\n  .account-session-history__label-mobile {\n    display: inline;\n  }\n\n  .account-session-history__toolbar {\n    top: 0;\n  }\n}\n\n.account-filter-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.account-filter-actions-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.account-filter-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.34rem 0.62rem;\n  border: 1px solid #d8dee8;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #334155;\n  font-size: 0.77rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.account-filter-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.account-filter-btn:focus-visible {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.16);\n}\n\n.account-filter-btn svg {\n  width: 13px;\n  height: 13px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n}\n\n.account-filter-btn--clear {\n  justify-content: center;\n}\n\n.account-filter-btn-clear-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 0.9rem;\n  height: 0.9rem;\n}\n\n.account-filter-btn-clear-mark svg {\n  width: 0.8rem;\n  height: 0.8rem;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.account-filter-dropdown {\n  position: absolute;\n  top: calc(100% + 0.45rem);\n  right: 0;\n  z-index: 4;\n  width: min(14.75rem, calc(100vw - 4rem));\n  padding: 0.55rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06);\n  display: grid;\n  gap: 0.55rem;\n}\n\n.account-filter-field {\n  display: grid;\n  gap: 0.32rem;\n}\n\n.account-filter-field span {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.account-filter-choice {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.18rem 0.05rem;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  font-size: 0.8rem;\n  color: #334155;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.account-filter-choice input {\n  margin: 0;\n  accent-color: #2563eb;\n}\n\n.account-filter-choice input:checked + .account-filter-choice-copy {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.account-filter-type-dropdown {\n  position: relative;\n}\n\n.account-filter-type-trigger {\n  width: 100%;\n  min-height: 2.05rem;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid #d8dee8;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #334155;\n  font-size: 0.8rem;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.account-filter-type-trigger:hover {\n  border-color: #d1d5db;\n  background: #f8fafc;\n}\n\n.account-filter-type-trigger.open,\n.account-filter-type-trigger:focus-visible {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.16);\n}\n\n.account-filter-type-trigger-copy {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.account-filter-type-trigger-arrow {\n  flex-shrink: 0;\n  color: #4b5563;\n}\n\n.account-filter-type-trigger-arrow svg {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.account-filter-type-menu {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  right: 0;\n  width: 100%;\n  max-height: 12rem;\n  overflow-y: auto;\n  background: var(--surface-color);\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.06);\n  padding: 0.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  z-index: 5;\n}\n\n.account-filter-type-option {\n  width: 100%;\n  padding: 0.45rem 0.6rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #374151;\n  font-size: 0.8rem;\n  font-weight: 500;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.account-filter-type-option:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.account-filter-type-option.selected {\n  background: rgba(37, 99, 235, 0.08);\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.account-filter-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.account-filter-apply-btn {\n  padding: 0.32rem 0.58rem;\n  border: 1px solid rgba(59, 130, 246, 0.4);\n  border-radius: 7px;\n  background: rgba(219, 234, 254, 0.95);\n  color: #1d4ed8;\n  font-size: 0.76rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.account-history-carousel-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.account-history-carousel-controls--card {\n  margin-top: 0.85rem;\n}\n\n.account-history-card-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.45rem;\n  margin-top: 0.9rem;\n}\n\n.account-history-card-nav--inline {\n  margin-top: 0;\n  justify-self: end;\n}\n\n.account-history-card-nav-position {\n  font-size: 0.85rem;\n  opacity: 0.75;\n}\n\n.account-history-card-nav-position--center {\n  justify-self: center;\n}\n\n.account-history-card-nav-buttons {\n  display: flex;\n  align-items: center;\n  gap: 1.1rem;\n}\n\n.account-history-nav-btn {\n  border: none;\n  background: transparent;\n  color: #475569;\n  min-width: 0;\n  padding: 0.1rem 0;\n  font-size: 0.95rem;\n  letter-spacing: 0.01em;\n  line-height: 1;\n  cursor: pointer;\n  transition: color 0.18s ease, transform 0.18s ease, opacity 0.18s ease;\n}\n\n.account-history-nav-btn:hover:not(:disabled) {\n  color: #0f172a;\n  transform: translateY(-1px);\n}\n\n.account-history-nav-btn--action {\n  font-size: 0.9rem;\n  justify-self: start;\n}\n\n.account-history-nav-btn:disabled {\n  opacity: 0.28;\n  cursor: not-allowed;\n}\n\n.App.dark .account-history-nav-btn {\n  background: transparent;\n  color: rgba(226, 232, 240, 0.78);\n}\n\n.App.dark .account-history-nav-btn:hover:not(:disabled) {\n  color: #f8fafc;\n}\n\n.App.dark .account-filter-btn {\n  border-color: #374151;\n  background: rgba(31, 41, 55, 0.96);\n  color: rgba(241, 245, 249, 0.9);\n}\n\n.App.dark .account-filter-btn:hover {\n  border-color: #4b5563;\n  background: #273244;\n}\n\n.App.dark .account-filter-btn:focus-visible {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.22);\n}\n\n.App.dark .account-filter-dropdown {\n  border-color: #374151;\n  background: #1f2937;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35), 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.App.dark .account-filter-field span {\n  color: rgba(226, 232, 240, 0.72);\n}\n\n.App.dark .account-filter-choice {\n  color: rgba(241, 245, 249, 0.9);\n}\n\n.App.dark .account-filter-choice input:checked + .account-filter-choice-copy {\n  color: #f8fafc;\n}\n\n.App.dark .account-filter-type-trigger {\n  border-color: #374151;\n  background: rgba(31, 41, 55, 0.96);\n  color: #f8fafc;\n}\n\n.App.dark .account-filter-type-trigger:hover {\n  border-color: #4b5563;\n  background: #273244;\n}\n\n.App.dark .account-filter-type-trigger.open,\n.App.dark .account-filter-type-trigger:focus-visible {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.22);\n}\n\n.App.dark .account-filter-type-trigger-arrow {\n  color: #d1d5db;\n}\n\n.App.dark .account-filter-type-menu {\n  background: #1f2937;\n  border-color: #374151;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35), 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.App.dark .account-filter-type-option {\n  color: #d1d5db;\n}\n\n.App.dark .account-filter-type-option:hover {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.App.dark .account-filter-type-option.selected {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n.App.dark .account-filter-apply-btn {\n  border-color: rgba(96, 165, 250, 0.45);\n  background: rgba(30, 64, 175, 0.34);\n  color: #93c5fd;\n}\n\n.account-history-position {\n  font-size: 0.9rem;\n  opacity: 0.75;\n}\n\n.account-history-card {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  background: rgba(248, 250, 252, 0.7);\n  min-width: 0;\n}\n\n.account-history-carousel {\n  overflow: visible;\n  perspective: 1000px;\n}\n\n.account-history-card--exit-next {\n  transform-origin: 12% 88%;\n  will-change: transform, opacity;\n  animation: account-card-exit-next 140ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;\n}\n\n.account-history-card--enter-next {\n  transform-origin: center top;\n  will-change: transform, opacity;\n  animation: account-card-enter-next 180ms cubic-bezier(0.22, 0.75, 0.25, 1) both;\n}\n\n.account-history-card--exit-previous {\n  transform-origin: center top;\n  will-change: transform, opacity;\n  animation: account-card-exit-previous 140ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;\n}\n\n.account-history-card--enter-previous {\n  transform-origin: 12% 88%;\n  will-change: transform, opacity;\n  animation: account-card-enter-previous 180ms cubic-bezier(0.2, 0.8, 0.25, 1) both;\n}\n\n@keyframes account-card-exit-next {\n  35% {\n    transform: translate(-4%, 5%) rotate(-2deg);\n    box-shadow: 0 14px 24px rgba(15, 23, 42, 0.18);\n  }\n\n  45% {\n    opacity: 1;\n    transform: translate(-30%, 45%) rotate(-11deg);\n    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.1);\n  }\n\n  95%,\n  to {\n    opacity: 0;\n    transform: translate(-110%, 98%) rotate(-19deg);\n    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.08);\n  }\n}\n\n@keyframes account-card-enter-next {\n  from {\n    opacity: 0.72;\n    transform: translateY(-0.65rem) scale(0.975);\n    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes account-card-exit-previous {\n  to {\n    opacity: 0.72;\n    transform: translateY(-0.65rem) scale(0.975);\n  }\n}\n\n@keyframes account-card-enter-previous {\n  from {\n    opacity: 0;\n    transform: translate(-110%, 98%) rotate(-19deg);\n    box-shadow: 0 24px 42px rgba(15, 23, 42, 0.08);\n  }\n\n  55% {\n    opacity: 1;\n    transform: translate(-30%, 45%) rotate(-11deg);\n  }\n\n  70% {\n    opacity: 1;\n    transform: translate(-2%, 2%) rotate(-1deg);\n    box-shadow: 0 14px 24px rgba(15, 23, 42, 0.18);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(0, 0) rotate(0);\n  }\n}\n\nhtml[data-account-card-direction=\"next\"]::view-transition-group(account-skills-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-group(account-strategies-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-group(account-session-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-group(account-skills-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-group(account-strategies-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-group(account-session-card) {\n  animation-duration: 320ms;\n}\n\nhtml[data-account-card-direction=\"next\"]::view-transition-new(account-skills-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-new(account-strategies-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-new(account-session-card) {\n  z-index: 1;\n  animation: account-card-underneath 320ms cubic-bezier(0.22, 0.75, 0.25, 1) both;\n}\n\nhtml[data-account-card-direction=\"next\"]::view-transition-old(account-skills-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-old(account-strategies-card),\nhtml[data-account-card-direction=\"next\"]::view-transition-old(account-session-card) {\n  z-index: 2;\n  transform-origin: 12% 88%;\n  animation: account-card-exit-next 220ms cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards;\n}\n\nhtml[data-account-card-direction=\"previous\"]::view-transition-old(account-skills-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-old(account-strategies-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-old(account-session-card) {\n  z-index: 1;\n  animation: none;\n}\n\nhtml[data-account-card-direction=\"previous\"]::view-transition-new(account-skills-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-new(account-strategies-card),\nhtml[data-account-card-direction=\"previous\"]::view-transition-new(account-session-card) {\n  z-index: 2;\n  transform-origin: 12% 88%;\n  animation: account-card-enter-previous 220ms cubic-bezier(0.2, 0.8, 0.25, 1) both;\n}\n\n@keyframes account-card-underneath {\n  from {\n    opacity: 0.82;\n    transform: translateY(-0.45rem) scale(0.985);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .account-history-card--exit-next,\n  .account-history-card--enter-next,\n  .account-history-card--exit-previous,\n  .account-history-card--enter-previous {\n    animation: none;\n  }\n\n  html[data-account-card-direction]::view-transition-old(account-skills-card),\n  html[data-account-card-direction]::view-transition-new(account-skills-card),\n  html[data-account-card-direction]::view-transition-old(account-strategies-card),\n  html[data-account-card-direction]::view-transition-new(account-strategies-card),\n  html[data-account-card-direction]::view-transition-old(account-session-card),\n  html[data-account-card-direction]::view-transition-new(account-session-card) {\n    animation: none;\n  }\n}\n\n.account-access-card {\n  display: grid;\n  gap: 0.65rem;\n  margin-top: 0.2rem;\n}\n\n.account-status-layout {\n  display: grid;\n  grid-template-columns: minmax(8.5rem, 0.3fr) minmax(0, 0.7fr);\n  gap: 0.85rem;\n  align-items: stretch;\n  justify-content: end;\n}\n\n.account-status-card {\n  display: grid;\n  gap: 0.7rem;\n  height: 14.5rem;\n  align-self: stretch;\n  overflow: hidden;\n}\n\n.account-status-card__body {\n  min-height: 0;\n  overflow-y: auto;\n  display: grid;\n  align-content: start;\n  gap: 0.7rem;\n  padding-right: 0.2rem;\n}\n\n.account-avatar-panel {\n  display: grid;\n  place-items: center;\n  gap: 0.7rem;\n  min-width: 0;\n}\n\n.account-avatar-panel__image-wrap {\n  position: relative;\n  width: clamp(8rem, 17vw, 10.5rem);\n  aspect-ratio: 1;\n}\n\n.account-avatar-panel__image {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.account-avatar-panel__change-btn {\n  position: absolute;\n  right: 0.1rem;\n  bottom: 0.1rem;\n  width: 2.35rem;\n  height: 2.35rem;\n  border: 1px solid rgba(37, 99, 235, 0.22);\n  border-radius: 0.72rem;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  background: rgba(239, 246, 255, 0.98);\n  color: #1d4ed8;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.16);\n  cursor: pointer;\n  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;\n}\n\n.account-avatar-panel__change-btn:hover {\n  transform: translateY(-1px);\n  background: rgba(219, 234, 254, 0.98);\n  border-color: rgba(37, 99, 235, 0.36);\n}\n\n.account-avatar-panel__change-btn svg {\n  width: 1.2rem;\n  height: 1.2rem;\n  display: block;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.account-avatar-panel__name {\n  max-width: 100%;\n  color: #1f2937;\n  font-size: 1rem;\n  line-height: 1.25;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.account-avatar-editor {\n  display: grid;\n  grid-template-rows: auto auto auto;\n  align-content: start;\n  gap: 0.6rem;\n}\n\n.account-avatar-editor__section {\n  min-width: 0;\n  display: grid;\n  align-items: center;\n}\n\n.account-avatar-editor__subtitle {\n  margin: 0 0 0.35rem;\n  color: #475569;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.account-avatar-editor__grid {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.account-avatar-editor__grid--avatars {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.4rem;\n}\n\n.account-avatar-editor__avatar-option,\n.account-avatar-editor__background-option {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n\n.account-avatar-editor__avatar-option {\n  display: grid;\n  place-items: center;\n}\n\n.account-avatar-editor__avatar-option svg {\n  width: 2.7rem;\n  height: 2.7rem;\n  display: block;\n  border-radius: 50%;\n  transition: box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.account-avatar-editor__avatar-option:hover svg {\n  transform: translateY(-1px);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35);\n}\n\n.account-avatar-editor__avatar-option.is-selected svg {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.78);\n}\n\n.account-avatar-editor__error {\n  color: #b91c1c;\n  font-size: 0.9rem;\n}\n\n.account-avatar-editor__actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.8rem;\n}\n\n.account-avatar-editor__slider {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.account-avatar-editor__slider input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  margin: 0;\n  accent-color: #2563eb;\n  height: 0.7rem;\n  border-radius: 999px;\n  background: linear-gradient(\n    90deg,\n    hsl(0 88% 92%),\n    hsl(60 88% 92%),\n    hsl(120 88% 92%),\n    hsl(180 88% 92%),\n    hsl(240 88% 92%),\n    hsl(300 88% 92%),\n    hsl(360 88% 92%)\n  );\n  cursor: pointer;\n}\n\n.account-avatar-editor__slider input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  background: #2563eb;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.24);\n}\n\n.account-avatar-editor__slider input::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  background: #2563eb;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.24);\n}\n\n.account-avatar-editor__slider input::-moz-range-track {\n  height: 0.7rem;\n  border: none;\n  border-radius: 999px;\n  background: linear-gradient(\n    90deg,\n    hsl(0 88% 92%),\n    hsl(60 88% 92%),\n    hsl(120 88% 92%),\n    hsl(180 88% 92%),\n    hsl(240 88% 92%),\n    hsl(300 88% 92%),\n    hsl(360 88% 92%)\n  );\n}\n\n.account-avatar-editor__btn-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.45rem;\n  flex: 0 0 auto;\n}\n\n.account-avatar-editor__btn {\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  border-radius: 0.7rem;\n  padding: 0.42rem 0.82rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.account-avatar-editor__btn:disabled {\n  opacity: 0.62;\n  cursor: not-allowed;\n}\n\n.account-avatar-editor__btn--ghost {\n  background: rgba(255, 255, 255, 0.64);\n  color: #475569;\n}\n\n.account-avatar-editor__btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #ffffff;\n}\n\n.account-avatar-panel__image svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.account-access-card p {\n  margin: 0;\n}\n\n.account-access-copy {\n  display: grid;\n  gap: 0.55rem;\n  min-width: 0;\n}\n\n.account-access-status-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  position: relative;\n}\n\n.account-access-status-row p {\n  min-width: 0;\n}\n\n.account-access-status-row--hoverable {\n  cursor: default;\n}\n\n.account-access-hover-note {\n  position: absolute;\n  top: calc(100% + 0.45rem);\n  left: 0;\n  z-index: 2;\n  width: min(28rem, calc(100vw - 6rem));\n  padding: 0.7rem 0.85rem;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 10px;\n  background: rgba(248, 250, 252, 0.96);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);\n  color: #475569;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-0.2rem);\n  pointer-events: none;\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;\n}\n\n.account-access-status-row--hoverable:hover .account-access-hover-note {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.App.dark .account-access-card {\n  background: transparent;\n  border-color: transparent;\n}\n\n.App.dark .account-avatar-panel__image {\n  background: rgba(15, 23, 42, 0.86);\n}\n\n.App.dark .account-avatar-panel__change-btn {\n  border-color: rgba(96, 165, 250, 0.26);\n  background: rgba(15, 23, 42, 0.96);\n  color: #bfdbfe;\n  box-shadow: 0 10px 22px rgba(2, 6, 23, 0.36);\n}\n\n.App.dark .account-avatar-panel__change-btn:hover {\n  background: rgba(30, 41, 59, 0.98);\n  border-color: rgba(147, 197, 253, 0.42);\n}\n\n.App.dark .account-avatar-panel__name {\n  color: #f9fafb;\n}\n\n.App.dark .account-avatar-editor__avatar-option {\n  background: transparent;\n}\n\n.App.dark .account-avatar-editor__subtitle {\n  color: rgba(203, 213, 225, 0.86);\n}\n\n.App.dark .account-avatar-editor__slider input {\n  accent-color: #93c5fd;\n}\n\n.App.dark .account-avatar-editor__slider input::-webkit-slider-thumb {\n  background: #93c5fd;\n}\n\n.App.dark .account-avatar-editor__slider input::-moz-range-thumb {\n  background: #93c5fd;\n}\n\n.App.dark .account-avatar-editor__avatar-option:hover svg {\n  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.52);\n}\n\n.App.dark .account-avatar-editor__avatar-option.is-selected svg {\n  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.84);\n}\n\n.App.dark .account-avatar-editor__error {\n  color: #fca5a5;\n}\n\n.App.dark .account-avatar-editor__btn--ghost {\n  background: rgba(15, 23, 42, 0.6);\n  color: rgba(226, 232, 240, 0.86);\n}\n\n.App.dark .account-avatar-editor__btn--primary {\n  background: #1d4ed8;\n  border-color: #3b82f6;\n  color: #eff6ff;\n}\n\n.App.dark .account-access-hover-note {\n  border-color: rgba(75, 85, 99, 0.8);\n  background: rgba(15, 23, 42, 0.96);\n  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.35);\n  color: rgba(226, 232, 240, 0.86);\n}\n\n.App.dark .account-history-card {\n  background: rgba(17, 24, 39, 0.45);\n  border-color: rgba(75, 85, 99, 0.8);\n}\n\n.account-history-card-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: baseline;\n  margin-bottom: 0.75rem;\n}\n\n.account-history-card-head-main {\n  display: grid;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.account-history-card-head-main strong {\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.account-attempt-retry-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n.account-attempt-retry-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  height: auto;\n  padding: 0 0.1rem;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 1.15rem;\n  line-height: 1;\n  transform: translateY(-0.1rem);\n  cursor: pointer;\n}\n\n.account-attempt-retry-btn:hover:not(:disabled) {\n  color: #2563eb;\n}\n\n.account-attempt-retry-btn:disabled {\n  cursor: default;\n  opacity: 0.3;\n}\n\n.App.dark .account-attempt-retry-nav,\n.app-overlay-root.dark .account-attempt-retry-nav {\n  color: #cbd5e1;\n}\n\n.account-history-card-position {\n  font-size: 0.82rem;\n  opacity: 0.72;\n}\n\n.account-history-card-head span {\n  font-size: 0.85rem;\n  opacity: 0.75;\n}\n\n.account-history-card-footer {\n  flex: 0 0 auto;\n  margin-top: 0.8rem;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.account-history-card-date {\n  font-size: 0.85rem;\n  opacity: 0.75;\n}\n\n.account-history-card-date__short,\n.miti-chip__label-short {\n  display: none;\n}\n\n.App.App--single-column .account-history-card-date__full,\n.App.App--single-column .miti-chip--responsive-label .miti-chip__label-full {\n  display: none;\n}\n\n.App.App--single-column .account-history-card-date__short,\n.App.App--single-column .miti-chip--responsive-label .miti-chip__label-short {\n  display: inline;\n}\n\n.App.App--single-column .account-full-session-title-activated {\n  display: none;\n}\n\n.App.App--single-column .account-history-card--full-session .account-session-metrics {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.account-coding-chips {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  vertical-align: middle;\n}\n\n.account-coding-chips .miti-chip {\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  border-width: 1px;\n}\n\n.account-coding-chips .miti-chip--Q          { background: rgba(74,158,255,0.24);  border-color: rgba(74,158,255,0.48); }\n.account-coding-chips .miti-chip--S          { background: rgba(240,168,78,0.24);  border-color: rgba(240,168,78,0.48); }\n.account-coding-chips .miti-chip--AF         { background: rgba(76,175,136,0.24);  border-color: rgba(76,175,136,0.48); }\n.account-coding-chips .miti-chip--SR         { background: rgba(47,158,158,0.24);  border-color: rgba(47,158,158,0.48); }\n.account-coding-chips .miti-chip--CR         { background: rgba(201,126,240,0.24); border-color: rgba(201,126,240,0.48); }\n.account-coding-chips .miti-chip--Seek       { background: rgba(240,168,78,0.24);  border-color: rgba(240,168,78,0.48); }\n.account-coding-chips .miti-chip--GI         { background: rgba(56,189,248,0.24);  border-color: rgba(56,189,248,0.48); }\n.account-coding-chips .miti-chip--Persuade   { background: rgba(251,113,133,0.24); border-color: rgba(251,113,133,0.48); }\n.account-coding-chips .miti-chip--Persuade_with { background: rgba(251,146,60,0.24); border-color: rgba(251,146,60,0.48); }\n.account-coding-chips .miti-chip--Emphasize  { background: rgba(52,211,153,0.24);  border-color: rgba(52,211,153,0.48); }\n.account-coding-chips .miti-chip--Confront   { background: rgba(239,68,68,0.24);   border-color: rgba(239,68,68,0.48); }\n.account-coding-chips .miti-chip--NC         { background: rgba(156,163,175,0.2);  border-color: rgba(156,163,175,0.42); }\n\n.account-coding-chips--bubble {\n  flex-shrink: 0;\n  justify-content: flex-end;\n}\n\n.account-attempt-choice-pill {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n  max-width: 13.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 0 1 auto;\n  padding: 0.14rem 0.42rem;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #e5e7eb;\n  color: #475569;\n  font-size: 0.68rem;\n  font-weight: 600;\n  line-height: 1.15;\n  letter-spacing: 0.03em;\n}\n\n.account-attempt-bubble {\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0.95rem 0;\n  padding: 0.95rem 1.1rem 1.05rem;\n  border-radius: 18px;\n  border: none;\n}\n\n.account-attempt-bubble--user {\n  border-bottom-right-radius: 8px;\n  background: #d7dce3;\n}\n\n.account-attempt-bubble--assistant {\n  border-bottom-left-radius: 8px;\n  background: #c3cad4;\n}\n\n.account-attempt-bubble__label {\n  display: inline-block;\n  margin-bottom: 0.45rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.account-attempt-bubble__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.45rem;\n}\n\n.account-attempt-bubble__head .account-attempt-bubble__label {\n  margin-bottom: 0;\n}\n\n.account-attempt-bubble__text {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  color: #1f2937;\n  line-height: 1.58;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.account-attempt-bubble__text--input {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: normal;\n}\n\n.account-attempt-bubble__text--feedback {\n  height: calc(1.58em * 4);\n  overflow-y: auto;\n}\n\n.account-attempt-bubble__avatar {\n  position: absolute;\n  bottom: -0.55rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  background: #ffffff;\n}\n\n.account-attempt-bubble__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.account-attempt-bubble__avatar--user {\n  right: 0.7rem;\n}\n\n.account-attempt-bubble__avatar--assistant {\n  left: 0.7rem;\n}\n\n.account-session-end-reason {\n  margin: 1rem 0 0.65rem;\n  padding: 0.72rem 0.82rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.65rem;\n  background: rgba(255, 255, 255, 0.42);\n  text-align: left;\n}\n\n.account-session-end-reason__label {\n  display: block;\n  color: #6b7280;\n  font-size: 0.73rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: left;\n}\n\n.account-session-end-reason__value {\n  margin: 0.38rem 0 0;\n  color: #1f2937;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.account-session-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.65rem;\n  margin: 0.75rem 0;\n}\n\n.account-session-metric {\n  min-width: 0;\n  display: grid;\n  gap: 0.28rem;\n}\n\n.account-session-metric__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.account-session-metric__value {\n  font-size: 0.98rem;\n  font-weight: 600;\n  color: #0f172a;\n  line-height: 1.25;\n}\n\n.account-download-btn {\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.85);\n  color: #0f172a;\n  padding: 0.55rem 0.95rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.account-download-btn--icon {\n  min-width: 2.4rem;\n  padding: 0.5rem 0.7rem;\n  font-size: 1.05rem;\n  line-height: 1;\n}\n\n.account-download-btn:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n.App.dark .account-download-btn {\n  background: rgba(31, 41, 55, 0.85);\n  color: #f8fafc;\n  border-color: rgba(75, 85, 99, 0.9);\n}\n\n.App.dark .account-session-end-reason {\n  background: rgba(15, 23, 42, 0.22);\n  border-color: rgba(75, 85, 99, 0.75);\n}\n\n.App.dark .account-session-end-reason__label {\n  color: #9ca3af;\n}\n\n.App.dark .account-session-end-reason__value {\n  color: #e5e7eb;\n}\n\n.App.dark .account-session-metric__label {\n  color: rgba(226, 232, 240, 0.68);\n}\n\n.App.dark .account-attempt-choice-pill {\n  border-color: #4b5563;\n  background: #374151;\n  color: #cbd5e1;\n}\n\n.App.dark .account-session-metric__value {\n  color: #f8fafc;\n}\n\n.App.dark .account-attempt-bubble {\n  border: none;\n}\n\n.App.dark .account-attempt-bubble--user {\n  background: #4b5563;\n}\n\n.App.dark .account-attempt-bubble--assistant {\n  background: #303845;\n}\n\n.App.dark .account-attempt-bubble__label {\n  color: #d1d5db;\n}\n\n.App.dark .account-attempt-bubble__text {\n  color: #f9fafb;\n}\n\n.about-citation {\n  font-size: 0.85rem;\n  color: rgba(71, 85, 105, 0.9);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.about-citation a {\n  color: #1d4ed8;\n  text-decoration: none;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.about-citation a:hover {\n  text-decoration: underline;\n}\n\n.App.dark .about-citation {\n  color: rgba(226, 232, 240, 0.8);\n}\n\n.App.dark .about-citation a {\n  color: #93c5fd;\n}\n\n.App.dark .lectures-overlay-card,\n.app-overlay-root.dark .lectures-overlay-card {\n  background: transparent;\n}\n\n.App.dark .lectures-overlay-card:hover,\n.app-overlay-root.dark .lectures-overlay-card:hover {\n  opacity: 0.94;\n}\n\n.App.dark .lectures-overlay-card__thumb,\n.app-overlay-root.dark .lectures-overlay-card__thumb {\n  border-color: rgba(75, 85, 99, 0.72);\n}\n\n.profile-table,\n.io-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  font-size: 0.92rem;\n  -webkit-column-span: all;\n  column-span: all;\n}\n\n.profile-table th,\n.profile-table td,\n.io-table th,\n.io-table td {\n  border: 1px solid rgba(148, 163, 184, 0.5);\n  padding: 0.75rem;\n  vertical-align: top;\n}\n\n.profile-table th,\n.io-table th {\n  font-weight: 600;\n  background: rgba(249, 250, 251, 0.8);\n}\n\n.App.dark .profile-table th,\n.App.dark .io-table th {\n  background: rgba(55, 65, 81, 0.8);\n}\n\n@media (max-width: 768px) {\n  .section-popout-btn {\n    padding: 0.3rem 0.5rem;\n    font-size: 0.9rem;\n  }\n\n  .lectures-overlay-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .landing-overlay-content,\n  .app-overlay-content {\n    padding-top: 2.25rem;\n  }\n\n  .client-info-panel h2 {\n    font-size: 1.25rem;\n  }\n\n  .client-info-panel p {\n    font-size: 0.9rem;\n    line-height: 1.6;\n  }\n\n  .account-status-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .account-status-card {\n    height: 15.5rem;\n  }\n\n  .account-avatar-panel__image-wrap {\n    width: clamp(6rem, 32vw, 8rem);\n  }\n\n  .account-avatar-editor__grid--avatars {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .account-avatar-editor__actions {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .account-avatar-editor__slider {\n    flex-basis: 100%;\n  }\n\n  .account-session-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* --- Account token usage section --- */\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.overlay-article .article-content > section.account-usage-section {\n  border-top: none;\n  padding-top: 0;\n}\n\n.overlay-article .article-content > section.account-usage-section + section {\n  margin-top: 1.1rem;\n}\n\n.account-usage-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  height: 19.2rem;\n  overflow: hidden;\n  transition: opacity 0.15s ease;\n}\n\n.account-usage-card.is-refetching {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.account-usage-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.account-usage-summary {\n  flex: 1 1 auto;\n}\n\n.account-usage-chip-group {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.3rem;\n  margin-left: auto;\n}\n\n.account-usage-chip {\n  padding: 0.3rem 0.6rem;\n  border: 1px solid #d8dee8;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #334155;\n  font-size: 0.74rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.account-usage-chip:hover {\n  border-color: rgba(59, 130, 246, 0.55);\n}\n\n.account-usage-chip.is-active {\n  border-color: rgba(59, 130, 246, 0.55);\n  background: rgba(219, 234, 254, 0.95);\n  color: #1d4ed8;\n}\n\n.account-usage-range-menu-wrap {\n  display: none;\n  position: relative;\n  margin-left: auto;\n}\n\n.account-usage-range-trigger {\n  min-width: 6.2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  padding: 0.35rem 0.55rem 0.35rem 0.65rem;\n  border: 1px solid #d8dee8;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #334155;\n  font-family: inherit;\n  font-size: 0.76rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.account-usage-range-trigger svg {\n  width: 0.8rem;\n  height: 0.8rem;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2.3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.account-usage-range-trigger:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.36);\n}\n\n.account-usage-range-menu {\n  position: absolute;\n  top: calc(100% + 0.35rem);\n  right: 0;\n  width: 7.7rem;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: var(--surface-color);\n  box-shadow: none;\n  z-index: 20;\n}\n\n.account-usage-range-item {\n  display: block;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #374151;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  padding: 0.58rem 0.72rem;\n  text-align: left;\n}\n\n.account-usage-range-item:hover,\n.account-usage-range-item.is-active {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.account-usage-summary {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.account-usage-summary__value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.15;\n  white-space: nowrap;\n}\n\n.account-usage-summary__unit {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.account-usage-summary__scope {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.account-usage-summary__delta {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.App.App--single-column .account-usage-summary__delta {\n  display: none;\n}\n\n.account-usage-summary__credits {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.account-usage-summary__credits.is-exhausted {\n  color: #b91c1c;\n}\n\n.App.dark .account-usage-summary__credits {\n  color: rgba(226, 232, 240, 0.68);\n}\n\n.App.dark .account-usage-summary__credits.is-exhausted {\n  color: #fca5a5;\n}\n\n.account-usage-chart {\n  position: relative;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.account-usage-chart svg {\n  display: block;\n  outline: none;\n}\n\n.account-usage-chart svg:focus-visible {\n  border-radius: 8px;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.45);\n}\n\n.account-usage-chart__gridline {\n  stroke: rgba(148, 163, 184, 0.28);\n  stroke-width: 1;\n}\n\n.account-usage-chart__baseline {\n  stroke: rgba(100, 116, 139, 0.5);\n  stroke-width: 1;\n}\n\n.account-usage-chart__tick {\n  fill: #64748b;\n  font-size: 0.66rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.account-usage-chart__line {\n  fill: none;\n  stroke: #3b82f6;\n  stroke-width: 2;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n}\n\n.account-usage-chart__area {\n  fill: rgba(59, 130, 246, 0.14);\n  stroke: none;\n}\n\n.account-usage-chart__crosshair {\n  stroke: rgba(100, 116, 139, 0.55);\n  stroke-width: 1;\n  stroke-dasharray: 3 3;\n}\n\n.account-usage-chart__marker {\n  fill: #3b82f6;\n  stroke: rgba(255, 255, 255, 0.95);\n  stroke-width: 2;\n}\n\n.account-usage-tooltip {\n  position: absolute;\n  top: 4px;\n  transform: translateX(-50%);\n  display: grid;\n  gap: 0.14rem;\n  padding: 0.42rem 0.6rem;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.97);\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);\n  pointer-events: none;\n  z-index: 3;\n  min-width: 7.5rem;\n}\n\n.account-usage-tooltip__value {\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.account-usage-tooltip__label {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.account-usage-tooltip__breakdown {\n  list-style: none;\n  margin: 0.18rem 0 0;\n  padding: 0.28rem 0 0;\n  border-top: 1px solid rgba(148, 163, 184, 0.3);\n  display: grid;\n  gap: 0.12rem;\n}\n\n.account-usage-tooltip__breakdown li {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  white-space: nowrap;\n}\n\n.account-usage-tooltip__breakdown-value {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.account-usage-tooltip__breakdown-label {\n  font-size: 0.68rem;\n  color: #64748b;\n}\n\n.account-usage-empty-note {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.App.dark .account-usage-chip {\n  border-color: #374151;\n  background: rgba(31, 41, 55, 0.85);\n  color: #cbd5f5;\n}\n\n.App.dark .account-usage-chip:hover {\n  border-color: rgba(96, 165, 250, 0.55);\n}\n\n.App.dark .account-usage-chip.is-active {\n  border-color: rgba(96, 165, 250, 0.45);\n  background: rgba(30, 64, 175, 0.34);\n  color: #93c5fd;\n}\n\n.App.dark .account-usage-range-trigger {\n  border-color: #374151;\n  background: rgba(31, 41, 55, 0.85);\n  color: #cbd5f5;\n}\n\n.App.dark .account-usage-range-menu {\n  background: #1f2937;\n  border-color: #4b5563;\n}\n\n.App.dark .account-usage-range-item {\n  color: #d1d5db;\n}\n\n.App.dark .account-usage-range-item:hover,\n.App.dark .account-usage-range-item.is-active {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.App.dark .account-usage-summary__value {\n  color: #f8fafc;\n}\n\n.App.dark .account-usage-summary__unit,\n.App.dark .account-usage-summary__scope,\n.App.dark .account-usage-summary__delta,\n.App.dark .account-usage-empty-note {\n  color: rgba(226, 232, 240, 0.68);\n}\n\n.App.dark .account-usage-chart__gridline {\n  stroke: rgba(75, 85, 99, 0.45);\n}\n\n.App.dark .account-usage-chart__baseline {\n  stroke: rgba(148, 163, 184, 0.45);\n}\n\n.App.dark .account-usage-chart__tick {\n  fill: rgba(226, 232, 240, 0.6);\n}\n\n.App.dark .account-usage-chart__area {\n  fill: rgba(59, 130, 246, 0.2);\n}\n\n.App.dark .account-usage-chart__marker {\n  stroke: rgba(17, 24, 39, 0.95);\n}\n\n.App.dark .account-usage-tooltip {\n  border-color: rgba(75, 85, 99, 0.8);\n  background: rgba(17, 24, 39, 0.97);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);\n}\n\n.App.dark .account-usage-tooltip__value,\n.App.dark .account-usage-tooltip__breakdown-value {\n  color: #f8fafc;\n}\n\n.App.dark .account-usage-tooltip__label,\n.App.dark .account-usage-tooltip__breakdown-label {\n  color: rgba(226, 232, 240, 0.68);\n}\n\n.App.dark .account-usage-tooltip__breakdown {\n  border-top-color: rgba(75, 85, 99, 0.7);\n}\n\n.App.App--single-column .account-usage-controls {\n  justify-content: space-between;\n}\n\n.App.App--single-column .account-usage-chip-group {\n  display: none;\n}\n\n.App.App--single-column .account-usage-range-menu-wrap {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
